import bootbox from 'bootbox';
import moment from 'moment';
import log, {LogLevel} from '@/scripts/logger';
import EventBus from '@/scripts/event-bus';
import psl from 'psl';
import store from '@/stores/index.js';
import status from '@/scripts/board/status';
import DefaultCard from '@/assets/images/CreditCards/cardSvg/u18-unknown-card.svg';
import VisaCard from '@/assets/images/CreditCards/cardSvg/Visa.svg';
import MasterCard from '@/assets/images/CreditCards/cardSvg/MasterCard.svg';
import AmericanExpressCard from '@/assets/images/CreditCards/cardSvg/Amex.svg';
import DiscoverCard from '@/assets/images/CreditCards/cardSvg/Discover.svg';
import JcbCard from '@/assets/images/CreditCards/cardSvg/JCB.svg';
import MaestroCard from '@/assets/images/CreditCards/cardSvg/Maestro.svg';
import DinersClubCard from '@/assets/images/CreditCards/cardSvg/DinersClub.svg';
export const responsiveHelpers = {
    getBreakpoints() {
        return {
            tiny: (el) => el.width > 0,
            xsmall: (el) => el.width > 160,
            small: (el) => el.width > 320,
            medium: (el) => el.width > 425,
            large: (el) => el.width > 768,
            xlarge: (el) => el.width > 1024,
            massive: (el) => el.width > 1920,
        };
    },

    getBreakpointClasses(context) {
        return {
            tiny: context.el.is.tiny,
            xsmall: context.el.is.xsmall,
            small: context.el.is.small,
            medium: context.el.is.medium,
            large: context.el.is.large,
            xlarge: context.el.is.xlarge,
            massive: context.el.is.massive,
        };
    },
};

export const helpers = {
    getFroalaKey() {
        return 'BA7A5C4D3F3A2H3tA6B4B3B2C7D1D2E1E4A3oa2Pe2HTPYh1RNc2E1KDc1==';
    },

    getFlagSVGUrl(isoCode) {
        return `https://cdn.honeycrm.com/app/flags/${isoCode}.svg`;
    },
    
    getJourneyStepTypeById(typeId) {
        switch (typeId) {
            case 1:
                return 'DELAY';
            case 2:
                return 'EMAIL';
            case 3:
                return 'CONDITION';
            default:
                return null;
        }
    },

    formatCurrency(x) {
        x = x || 0;
        x = parseFloat(x);
        x = x.toFixed(2);

        var parts = x.toString().split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

        if (parts[1][0] == '0' && parts[1][1] == '0') {
            x = '$' + parts[0];
        } else {
            x = '$' + parts.join('.');
        }

        return x;
    },

    getFilesTrackingUrl(fileGuid) {
        return `https://files.glasshive.net/${fileGuid}`;
    },

    mapParticipants(meetingResponse) {
        var participants = [];

        if (meetingResponse.ActivityParticipants.length > 0) {
            participants = meetingResponse.ActivityParticipants.map((participant) => {
                if (participant.Contact) {
                    return {
                        link: `/Contacts/${participant.Contact.Id}`,
                        name: helpers.getName(participant.Contact.FirstName, participant.Contact.LastName),
                        profileImageUrl: participant.Contact.ProfileImageUrl || require('../assets/images/avatar.png'),
                    };
                } else {
                    return {
                        link: `/SalesTeam/${participant.User.Id}`,
                        name: helpers.getName(participant.User.FirstName, participant.User.LastName),
                        profileImageUrl: participant.User.ProfileImageUrl || require('../assets/images/avatar.png'),
                    };
                }
            });
        } else {
            if (meetingResponse.Contact) {
                participants.push({
                    link: `/Contacts/${meetingResponse.Contact.Id}`,
                    name: helpers.getName(meetingResponse.Contact.FirstName, meetingResponse.Contact.LastName),
                    profileImageUrl: meetingResponse.Contact.ProfileImageUrl || require('../assets/images/avatar.png'),
                });
            }

            if (meetingResponse.User) {
                participants.push({
                    link: `/SalesTeam/${meetingResponse.User.Id}`,
                    name: helpers.getName(meetingResponse.User.FirstName, meetingResponse.User.LastName),
                    profileImageUrl: meetingResponse.User.ProfileImageUrl || require('../assets/images/avatar.png'),
                });
            }
        }

        return participants;
    },

    mapMessageParticipants(messageResponse) {
        var participants = [];

        if (messageResponse.Participants.length > 0) {
            participants = messageResponse.Participants.map((participant) => {
                if (participant.Contact) {
                    return {
                        link: `/Contacts/${participant.Contact.Id}`,
                        name: helpers.getName(participant.Contact.FirstName, participant.Contact.LastName),
                        profileImageUrl: participant.Contact.ProfileImageUrl || require('../assets/images/avatar.png'),
                    };
                }
            });
        } else {
            if (messageResponse.Contact) {
                participants.push({
                    link: `/Contacts/${messageResponse.Contact.Id}`,
                    name: helpers.getName(messageResponse.Contact.FirstName, messageResponse.Contact.LastName),
                    profileImageUrl: messageResponse.Contact.ProfileImageUrl || require('../assets/images/avatar.png'),
                });
            }
        }

        return participants;
    },

    getPageSizes() {
        return [
            {
                name: 'Custom Size',
                key: 'Custom',
                dimensions: '',
            },
            {
                name: 'A4',
                key: 'A4',
                dimensions: '8.27 x 11.7',
            },
            {
                name: 'Letter',
                key: 'Letter',
                dimensions: '8.5 x 11',
            },
            {
                name: 'Postcard',
                key: 'Paper5x7',
                dimensions: '5 x 7',
            },
            {
                name: 'Photo',
                key: 'Paper4x6',
                dimensions: '4 x 6',
            },
        ];
    },

    createBase64VideoThumbnail(name, sourceUrl) {
        return new Promise((resolve) => {
            const video = document.createElement('video');
            video.setAttribute('crossOrigin', 'anonymous');

            video.src = sourceUrl;

            video.addEventListener('loadeddata', function () {
                if (!isNaN(video.duration)) {
                    video.currentTime = 0;
                }
            });

            video.addEventListener('seeked', function () {
                const canvas = document.createElement('canvas');
                canvas.height = video.videoHeight;
                canvas.width = video.videoWidth;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                resolve({
                    sourceName: `${name}-thumbnail`,
                    sourceUrl: canvas.toDataURL(),
                });
            });
        });
    },

    getBase64Encoding(file) {
        return new Promise(function (resolve, reject) {
            var reader = new FileReader();

            reader.onloadend = function () {
                resolve(reader.result);
            };

            reader.readAsDataURL(file);
        });
    },

    updateResponsiveText(selector, minWidth, maxWidth, ratio) {
        ratio = ratio || 9.08;
        minWidth = minWidth || 320;
        maxWidth = maxWidth || 1311;
        var $window = $(window);
        var $content = $(selector);
        var $sideNav = $('#side-navigation');

        var sideNavWidth = $sideNav.width();
        var windowWidth = $window.width();

        var bodyWidth = windowWidth; //- sideNavWidth;

        if (windowWidth > minWidth && windowWidth < maxWidth) {
            var newFontSize = bodyWidth / ratio;
            $content.css('font-size', newFontSize + 'px');
        } else {
            $content.removeAttr('style');
        }
    },

    calculateOpenPercent(recipients, uniqueBounces, uniqueOpens) {
        var openPercent = recipients - uniqueBounces > 0 ? (100.0 * uniqueOpens) / (recipients - uniqueBounces) : 0;

        return openPercent.toFixed(2);
    },

    calculateClickPercent(uniqueOpens, uniqueClicks) {
        var clickPercent = uniqueOpens > 0 ? (100.0 * uniqueClicks) / uniqueOpens : 0;

        return clickPercent.toFixed(2);
    },

    getTwoValueDonutConfiguration(percent, label1, color1, label2, color2) {
        var colors = {
            red: {
                linearGradient: { x1: 0, x2: 1, y1: 0, y2: 0 },
                stops: [
                    [0, '#ff1d1f'],
                    [1, '#ff0a71'],
                ],
            },
            purple: {
                linearGradient: { x1: 0, x2: 1, y1: 0, y2: 0 },
                stops: [
                    [0, '#8d75e4'],
                    [1, '#bb78d4'],
                ],
            },
            orange: {
                linearGradient: { x1: 0, x2: 1, y1: 0, y2: 0 },
                stops: [
                    [0, '#e65c00'],
                    [1, '#f9d323'],
                ],
            },
            blue: {
                linearGradient: { x1: 0, x2: 1, y1: 0, y2: 0 },
                stops: [
                    [0, '#1fa2ff'],
                    [1, '#70ecdd'],
                ],
            },
            green: {
                linearGradient: { x1: 0, x2: 1, y1: 0, y2: 0 },
                stops: [
                    [0, '#28da35'],
                    [1, '#15eca4'],
                ],
            },
            gray: {
                linearGradient: { x1: 0, x2: 1, y1: 0, y2: 0 },
                stops: [
                    [0, '#8f8d9e'],
                    [1, '#a5a1bf'],
                ],
            },
        };

        var configuration = {
            chart: {
                plotBorderWidth: 0,
                plotShadow: false,
                events: {
                    load: function () {
                        var graphic = this.series[0].data[1].graphic;
                        setTimeout(function () {
                            var prevR = graphic.r;
                            graphic.attr({
                                r: prevR + 10,
                            });
                        }, 1001);
                    },
                },
            },
            credits: {
                enabled: false,
            },
            title: {
                text: '',
            },
            tooltip: {
                useHTML: true,
                followPointer: true,
                formatter: function () {
                    return `<div>
                                <div class="tool-tip-header">${this.point.name}</div>
                                <div class="tool-tip-value"><p><svg height="25" width ="25"><circle cx="10" cy="10" r="10" fill="${
                                    this.point.color
                                }"></circle></svg><strong>${this.point.percentage.toFixed(1)}%</strong></p></div>
                            </div>`;
                },
                borderRadius: 15,
                borderColor: 'rgba(243, 116, 49, 0.5)',
                backgroundColor: {
                    linearGradient: { x1: 0.5, x2: 0.5, y1: 1, y2: 0 },
                    stops: [
                        [0, 'rgba(242,96,99, 0.95)'],
                        [0.8, 'rgba(244,129,69, 0.95)'],
                        [1, 'rgba(244, 129, 69, 0.95)'],
                    ],
                },
            },
            plotOptions: {
                pie: {
                    size: '80%',
                    dataLabels: {
                        enabled: true,
                        style: {
                            color: 'rgb(118,118,118)',
                        },
                    },
                    startAngle: 0,
                    endAngle: 360,
                },
            },
            series: [
                {
                    type: 'pie',
                    name: '', //'Publication Viewership',
                    center: ['50%', '50%'],
                    size: '100%',
                    innerSize: '60%',
                    borderWidth: 0,
                    states: {
                        hover: {
                            halo: false,
                        },
                    },
                    shadow: {
                        color: '#999999',
                        offsetX: 1,
                        offsetY: 0,
                        opacity: 0.05,
                        width: 5,
                    },
                    dataLabels: {
                        enabled: false,
                        style: {},
                    },
                    data: [
                        {
                            name: label1,
                            y: 100 - percent,
                            color: {},
                        },
                        {
                            name: label2,
                            y: percent,
                            color: {},
                        },
                    ],
                },
            ],
        };

        configuration.series[0].data[0].color = colors[color1];
        configuration.series[0].data[1].color = colors[color2];

        return configuration;
    },

    getDefaultEmailCustomizationSettings() {
        return {
            backgroundColor: '#d8e2ee',
            backgroundFontColor: '#141414',
            canvasColor: '#ffffff',
            canvasFontColor: '#000000',
            primaryColor: '#000fb9',
            primaryFontColor: '#ffffff',
            secondaryColor: '#d5d5d5',
            secondaryFontColor: '#212529',
            buttonColor: '#ed7e33',
            buttonFontColor: '#ffffff',
            logoImageUrl: '',
            footer: 'Here is where your address would go.',
        };
    },

    getTodayMMDDYYYY() {
        var today = new Date();

        var dd = today.getDate();
        var mm = today.getMonth() + 1;

        var yyyy = today.getFullYear();

        if (dd < 10) {
            dd = '0' + dd;
        }

        if (mm < 10) {
            mm = '0' + mm;
        }

        return mm + '/' + dd + '/' + yyyy;
    },

    getMMDDYYYY(date) {
        var dd = date.getDate();
        var mm = date.getMonth() + 1;

        var yyyy = date.getFullYear();

        if (dd < 10) {
            dd = '0' + dd;
        }

        if (mm < 10) {
            mm = '0' + mm;
        }

        return mm + '/' + dd + '/' + yyyy;
    },

    getDaysInMonth(month, year) {
        return new Date(year, month + 1, 0).getDate();
    },

    secondsToHMS(seconds) {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const remainingSeconds = seconds % 60;
        const formattedHours = String(hours).padStart(2, '0');
        const formattedMinutes = String(minutes).padStart(2, '0');
        const formattedSeconds = String(remainingSeconds).padStart(2, '0');
        return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
    },

    getBillingDate(billingDay) {
        var billingDate;

        var today = new Date();
        var todayYear = today.getFullYear();
        var todayMonth = today.getMonth();
        var todayDay = today.getDate();
        var daysInMonth = null;

        if (todayDay <= billingDay) {
            daysInMonth = this.getDaysInMonth(todayMonth, todayYear);
            if (billingDay > daysInMonth) {
                billingDate = new Date(todayYear, todayMonth, daysInMonth);
            } else {
                billingDate = new Date(todayYear, todayMonth, billingDay);
            }
        } else {
            daysInMonth = this.getDaysInMonth(todayMonth + 1, todayYear);
            if (billingDay > daysInMonth) {
                billingDate = new Date(todayYear, todayMonth + 1, daysInMonth);
            } else {
                billingDate = new Date(todayYear, todayMonth + 1, billingDay);
            }
        }

        return billingDate;
    },

    normalizePercent(percent) {
        if (percent < 0) {
            return 0;
        } else if (percent > 100) {
            return 100;
        }

        return percent;
    },

    calculateSubscriptionTotal(
        contactCount,
        userCount,
        priceBracketInterval,
        pricePerBracket,
        pricePerUser,
        basePrice
    ) {
        var contactCount = contactCount;
        var userCount = userCount;
        var priceBracketInterval = priceBracketInterval;
        var basePrice = basePrice;
        var pricePerBracket = pricePerBracket;
        var pricePerUser = pricePerUser;

        var priceBracket = Math.floor(Math.abs(contactCount - 1) / priceBracketInterval);

        var chargedUsers = userCount > 2 ? userCount - 2 : 0;
        var usersPrice = chargedUsers * pricePerUser;
        var contactsPrice = priceBracket * pricePerBracket;

        return Math.floor(basePrice + usersPrice + contactsPrice);
    },

    getDaysBetweenDates(date1, date2) {
        var oneDayInMilliseconds = 1000 * 60 * 60 * 24;

        var date1InMilliseconds = date1.getTime();
        var date2InMilliseconds = date2.getTime();

        var difference = date2InMilliseconds - date1InMilliseconds;

        return Math.floor(difference / oneDayInMilliseconds);
    },

    parseDate(date) {
        var splitDate = date.split('-');
        var day = splitDate[2];
        var month = splitDate[1] - 1;
        var year = splitDate[0];

        var splitDay = day.split('T');
        day = splitDay[0];

        return new Date(Date.UTC(year, month, day));
    },

    getMonthDayYear(date) {
        var monthDayYear = date.split('/');
        return monthDayYear;
    },

    getCurrentPage() {
        var parsedSlug = this.parseSlug();

        if (!parsedSlug) {
            return 'Home';
        }

        switch (parsedSlug[1]) {
            case 'Clients':
                if (parsedSlug.length == 2) {
                    return 'Clients';
                }
                return this.helpers.getClientPage(parsedSlug);

            case 'OpportunityTypes':
                return 'Opportunities';
            case 'Library':
                return 'Library';
            case 'Categories':
                return 'Library';
            default:
                return parsedSlug[1];
        }
    },

    parseSlug() {
        var slug = window.location.pathname;
        if (slug != '/') {
            return window.location.pathname.split('/');
        } else {
            return null;
        }
    },

    getClientPage(parsedSlug) {
        switch (parsedSlug[parsedSlug.length - 1]) {
            case 'Marketing':
                return 'Marketing';
            case 'Lists':
                return 'Lists';
            case 'Contacts':
                return 'Contacts';
            case 'Companies':
                return 'Companies';
            case 'Sales':
                return 'Sales';
            case 'Pipeline':
                return 'Pipeline';
            case 'Leads':
                return 'Leads';
            case 'SalesTeam':
                return 'SalesTeam';
            case 'Tasks':
                return 'Tasks';
            case 'Settings':
                return 'Settings';
            case 'Opportunities':
                return 'Opportunities';
            case 'Create':
                return parsedSlug[parsedSlug.length - 2];
            case 'Listless':
                return parsedSlug[parsedSlug.length - 2];
            case 'OpportunityTypes':
                return 'Opportunities';
            case 'Campaigns':
                return 'Campaigns';
            case 'Templates':
                return 'Templates';
            case 'Library':
                return 'Library';
            case 'Categories':
                return 'Library';
            default:
                return null;
        }
    },

    hideBodyOverflow() {
        $('.body-content').css('overflow', 'hidden');
    },

    showBodyOverflow() {
        $('.body-content').css('overflow', 'auto');
    },

    initializeFileUploadOnChangeEvent(options) {
        var self = this;

        if (options.fileInputSelector) {
            var fileInputSelector = options.fileInputSelector;
            var successCallback = options.successCallback;
            var failCallback = options.failCallback;

            $(fileInputSelector).on('change', function (event) {
                var upload = {
                    name: '',
                    file: null,
                };

                var file = event.target.files[0];

                if (file) {
                    upload.name = file.name.replace(/\s/g, '-');
                    var reader = new FileReader();

                    reader.onloadend = function () {
                        if (self.isFileSizeValid(file, options)) {
                            upload.file = reader.result;

                            successCallback(upload, fileInputSelector);
                        } else {
                            failCallback(file, options);
                        }
                    };

                    reader.readAsDataURL(file);
                }
            });
        }
    },

    isFileSizeValid(file, options) {
        return file.size <= options.config.byteSizeLimit;
    },

    isFileTypeValid(file, options) {
        var isValid = false;

        for (var i = 0; i < options.config.acceptedFileTypes.length; i++) {
            if (file.type == options.config.acceptedFileTypes[i]) {
                isValid = true;
            }
        }

        return isValid;
    },

    calculateDealvalue(priceTypeId, price, duration) {
        if (priceTypeId == 1) {
            return price;
        } else {
            return price * duration;
        }
    },

    isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return email ? emailRegex.test(email) : false;
    },

    sanitizeFileName(fileName) {
        const sanitizedFileName = fileName.replace(/[^a-zA-Z0-9._-]/g, '-');
        return fileName ? sanitizedFileName : false;
    },

    isDocumentType(mimeType,type){
        if(mimeType){
            return this.getDocumentTypeFromMimeType(mimeType) === type
        }

        return false
    },

    getDocumentTypeFromMimeType(mimeType) {
        var documentType = '';

        switch (mimeType) {
            case 'application/msword':
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            case 'text/plain':
                documentType = 'document';
                break;
            case 'application/pdf':
                documentType = 'pdf';
                break;
            case 'text/csv':
            case 'application/vnd.ms-excel':
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            case 'application/octet-stream':
                documentType = 'excel';
                break;
            case 'image/png':
            case 'image/jpeg':
            case 'image/jpg':
                documentType = 'image';
                break;
            case 'image/svg+xml': 
                documentType='svg'
                break;
            case 'video/mp4':
            case 'video/x-flv':
            case 'video/msvideo':
            case 'video/avi':
            case 'video/x-msvideo':
            case 'video/quicktime':
                documentType = 'video';
                break;
            case 'application/zip':
            case 'application/x-rar-compressed':
            case 'application/x-7z-compressed':
            case 'application/x-gzip':
            case 'application/x-gtar':
            case 'application/x-tgz':
            case 'application/x-zip-compressed':
                documentType = 'zip';
                break;
            case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            case 'application/vnd.ms-powerpoint':
            case 'application/vnd.google-apps.presentation':
                documentType = 'presentation';
                break;
            case 'audio/mpeg':
            case 'audio/flac':
            case 'audio/aac':
            case 'audio/wav':
                documentType = 'audio';
                break;
            default:
                documentType = 'blank';
                break;
        }

        return documentType;
    },

    getThumbnailUrlFromMimeType(mimeType) {
        var url = '';

        switch (mimeType) {
            case 'application/msword':
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            case 'text/plain':
                url = 'https://cdn.honeycrm.com/app/document-file1.png';
                break;
            case 'application/pdf':
                url = 'https://cdn.honeycrm.com/app/pdf-file.png';
                break;
            case 'text/csv':
            case 'application/vnd.ms-excel':
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            case 'application/octet-stream':
                url = 'https://cdn.honeycrm.com/app/excel-file.png';
                break;
            case 'image/png':
            case 'image/jpeg':
            case 'image/jpg':
                url = 'https://cdn.honeycrm.com/app/image-file.png';
                break;
            case 'video/mp4':
            case 'video/x-flv':
            case 'video/msvideo':
            case 'video/avi':
            case 'video/x-msvideo':
            case 'video/quicktime':
                url = 'https://cdn.honeycrm.com/app/video-file.png';
                break;
            case 'application/zip':
            case 'application/x-rar-compressed':
            case 'application/x-7z-compressed':
            case 'application/x-gzip':
            case 'application/x-gtar':
            case 'application/x-tgz':
            case 'application/x-zip-compressed':
                url = 'https://cdn.honeycrm.com/app/zip-file.png';
                break;
            case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            case 'application/vnd.ms-powerpoint':
            case 'application/vnd.google-apps.presentation':
                url = 'https://cdn.honeycrm.com/app/presentation-file.png';
                break;
            case 'audio/mpeg':
            case 'audio/flac':
            case 'audio/aac':
            case 'audio/wav':
                url = 'https://cdn.honeycrm.com/app/video-file.png';
                break;
            default:
                url = 'https://cdn.honeycrm.com/app/other-file.png';
                break;
        }

        return url;
    },

    initializeBootboxOptions() {
        bootbox.setDefaults({
            backdrop: true,
        });
    },

    createScriptElement(options) {
        var element = document.createElement('script');

        options = options || {};
        options.attributes = options.attributes || [];

        options.attributes.forEach((attribute) => {
            element.setAttribute(attribute.name, attribute.value);
        });

        return element;
    },

    getTimezones() {
        var timezoneNamesWithOffsets = [];
        var whiteListNames = helpers.whiteListedTimezones;
        var currentTime = moment.utc();
        for (var i = 0; i < whiteListNames.length; i++) {
            var timezone = {
                name: whiteListNames[i],
                offset: moment.tz(currentTime, whiteListNames[i]).utcOffset() / 60,
                display: '',
            };
            timezone.display = helpers.getFormattedDisplay(timezone);
            timezoneNamesWithOffsets.push(timezone);
        }
        return timezoneNamesWithOffsets;
    },

    guessTimezone() {
        var timezones = helpers.getTimezones();
        var guess = moment.tz.guess();
        var offset = moment.tz(moment.utc(), guess).utcOffset() / 60;

        var timezone = {
            name: helpers.getTimezoneByOffset(timezones, offset),
            offset: offset,
            display: '',
        };

        timezone.display = helpers.getFormattedDisplay(timezone);
 
        return timezone;
    },

    getFormattedDisplay(timezone) {
        var display = '';
        
        var name = timezone.name.replace('_', ' ');
        if (timezone.offset < 0) {
            if (timezone.offset > -10) {
                var stringifiedInt = String(timezone.offset);
                var offsetWithoutSign = stringifiedInt.substring(1);
                display = '(GMT-0' + offsetWithoutSign + ':00) ' + name;
            } else {
                display = '(GMT' + timezone.offset + ':00) ' + name;
            }
        } else {
            if (timezone.offset < 10) {
                display = '(GMT+0' + timezone.offset + ':00) ' + name;
            } else {
                display = '(GMT+' + timezone.offset + ':00) ' + name;
            }
        }

        return display;
    },

    getTimezoneByOffset(timezones, offset) {
        for (var i = 0; i < timezones.length; i++) {
            if (timezones[i].offset == offset) {
                return timezones[i].name;
            }
        }
    },

    getTimezoneByName(name) {
        var timezone = null;

        if (name) {
            var currentTime = moment.utc();

            var timezone = {
                name: name,
                offset: moment.tz(currentTime, name).utcOffset() / 60,
                display: null,
            };

            timezone.display = helpers.getFormattedDisplay(timezone);
        }

        return timezone;
    },

    getCompanyTypeBackgroundClass(color) {
        switch (color) {
            case 'Purple':
                return 'purple-gradient-bg';
            case 'DarkBlue':
                return 'dark-blue-gradient-bg';
            case 'Orange':
                return 'orange-gradient-bg';
            case 'Red':
                return 'red-gradient-bg';
            case 'Pink':
                return 'pink-gradient-bg';
            case 'Blue':
                return 'blue-gradient-bg';
            case 'Green':
                return 'green-gradient-bg';
            case 'Grey':
                return 'grey-gradient-bg';
            default:
                return 'grey-gradient-bg';
        }
    },

    getStatusBackgroundClass(color) {
        switch (color) {
            case 'Purple':
                return 'purple-gradient-bg';
            case 'DarkBlue':
                return 'dark-blue-gradient-bg';
            case 'Orange':
                return 'orange-gradient-bg';
            case 'Red':
                return 'red-gradient-bg';
            case 'Pink':
                return 'pink-gradient-bg';
            case 'Blue':
                return 'blue-gradient-bg';
            case 'Green':
                return 'green-gradient-bg';
            case 'Grey':
                return 'grey-gradient-bg';
            default:
                return 'grey-gradient-bg';
        }
    },

    getServiceBillingTypes() {
        return [
            {
                value: 1,
                name: 'PerEmployee',
                display: 'Per Employee',
            },
            {
                value: 2,
                name: 'PerDevice',
                display: 'Per Device',
            },
            {
                value: 3,
                name: 'Fixed',
                display: 'Fixed',
            },
        ];
    },

    getSolutionTypes() {
        return  [
            {
                value: 1,
                name: 'Service',
                display: 'Service',
            },
            {
                value: 2,
                name: 'Product',
                display: 'Product',
            },
            {
                value: 3,
                name: 'Product Charge',
                display: 'Product Charge',
            },
            {
                value: 4,
                name: 'Non-Inventory',
                display: 'Non-Inventory',
            }

        ]
    },

    getSolutionBillingTypes() {
        return [
            {
                value: 1,
                name: 'Per Employee',
                display: 'Per Employee',
            },
            {
                value: 2,
                name: 'Per Location',
                display: 'Per Location',
            },
            {
                value: 3,
                name: 'Per Device',
                display: 'Per Device',
            },
           {
                value: 4,
                name: 'Per Unit',
                display: 'Per Unit',
           },
           {
                value: 5,
                name: 'Fixed',
                display: 'Fixed',
           }
        ]
    },

    getSolutionBillingCycles(){
        return [
            {
                value: 0,
                name: 'One-time',
                display: 'One-time',
            },
            {
                value: 5,
                name: 'Hourly',
                display: 'Hourly',
            },
            {
                value: 1,
                name: 'Monthly',
                display: 'Monthly',
            },
            {
                value: 2,
                name: 'Quarterly',
                display: 'Quarterly' ,
            },
            {
                value: 3,
                name: 'Semi-annually',
                display: 'Semi-annually',
            },
            {
                value: 4,
                name: 'Annually',
                display: 'Annually',
            },
        ]
    },

    getTermInMonths(billingCycle) {
        const {name} = billingCycle;

        switch(name){
            case 'One-time':
            case 'Hourly':
            case 'Monthly':
                return 1;
            case 'Quarterly':
                return 4;
            case 'Semi-annually':
                return 6;
            case 'Annually':
                return 12
            default:
                return 0;
        }
    },

    calculateMargin(item){
        const { billingCycle , cost: unitCost, price: unitPrice, unitDiscountAmount, termInMonths, qty } = item
        const priceWithDiscount = (unitPrice - unitDiscountAmount).toFixed(2)
        const totalMargin = (priceWithDiscount - unitCost) * qty
        const defaultMonths = this.getTermInMonths({name:billingCycle})

        return (totalMargin*Math.floor(termInMonths/defaultMonths)) || 0;
    },

    calculateGrossMarginPercentage(grossMargin, lifetimeValue){
        if(grossMargin === 0 || lifetimeValue === 0) {
            return 0;
        }
        return Math.round((grossMargin / Math.abs(lifetimeValue)) * 100)
    },

    getBillingCycles() {
        return [
            {
                value: 1,
                name: 'Monthly',
            },
            {
                value: 12,
                name: 'Yearly',
            },
        ];
    },

    getName(firstName, lastName) {
        var name = '';

        if (firstName && lastName) {
            name = `${firstName} ${lastName}`;
        } else if (firstName) {
            name = firstName;
        } else if (lastName) {
            name = lastName;
        } else {
            name = 'No Name';
        }

        return name;
    },

    whiteListedTimezones: [
        'US/Eastern',
        'US/Central',
        'US/Mountain',
        'US/Pacific',
        'Pacific/Apia',
        'Antarctica/South_Pole',
        'NZ',
        'Pacific/Auckland',
        'Pacific/Fiji',
        'Asia/Anadyr',
        'Kwajalein',
        'Pacific/Wake',
        'Asia/Sakhalin',
        'Asia/Calcutta',
        'Australia/Melbourne',
        'Australia/Sydney',
        'Pacific/Bougainville',
        'Antarctica/DumontDUrville',
        'Asia/Ust-Nera',
        'Australia/Queensland',
        'Pacific/Guam',
        'Asia/Pyongyang',
        'Asia/Seoul',
        'Asia/Tokyo',
        'Japan',
        'Asia/Hong_Kong',
        'Asia/Macao',
        'Asia/Shanghai',
        'Asia/Singapore',
        'Australia/West',
        'Australia/Adelaide',
        'Asia/Bangkok',
        'Asia/Ho_Chi_Minh',
        'Asia/Novosibirsk',
        'Asia/Saigon',
        'Asia/Almaty',
        'Asia/Dacca',
        'Asia/Dhaka',
        'Indian/Chagos',
        'Asia/Ashgabat',
        'Asia/Samarkand',
        'Indian/Maldives',
        'Asia/Dubai',
        'Asia/Yerevan',
        'Europe/Saratov',
        'Indian/Mahe',
        'Africa/Nairobi',
        'Asia/Kuwait',
        'Europe/Moscow',
        'Turkey',
        'Africa/Johannesburg',
        'Asia/Damascus',
        'Asia/Jerusalem',
        'Europe/Athens',
        'Israel',
        'Africa/Algiers',
        'Europe/Amsterdam',
        'Europe/Copenhagen',
        'Europe/Madrid',
        'Europe/Monaco',
        'Europe/Prague',
        'Europe/Rome',
        'Europe/Stockholm',
        'Europe/Warsaw',
        'Europe/Zurich',
        'Poland',
        'Africa/Casablanca',
        'Africa/Dakar',
        'Atlantic/Reykjavik',
        'Atlantic/St_Helena',
        'Europe/Dublin',
        'Europe/Isle_of_Man',
        'Europe/London',
        'Iceland',
        'Portugal',
        'America/Scoresbysund',
        'Atlantic/Cape_Verde',
        'America/Sao_Paulo',
        'Brazil/DeNoronha',
        'Brazil/East',
        'America/Argentina/Buenos_Aires',
        'America/Argentina/Mendoza',
        'America/Montevideo',
        'America/Santiago',
        'Chile/Continental',
        'America/Dominica',
        'America/La_Paz',
        'America/Puerto_Rico',
        'America/Santo_Domingo',
        'Brazil/West',
        'Canada/Atlantic',
        'America/Montreal',
        'America/New_York',
        'America/Toronto',
        'Canada/Eastern',
        'Cuba',
        'America/Belize',
        'America/Chicago',
        'America/Costa_Rica',
        'America/Mexico_City',
        'Canada/Central',
        'America/Denver',
        'America/Phoenix',
        'Canada/Mountain',
        'US/Mountain',
        'America/Los_Angeles',
        'America/Tijuana',
        'America/Vancouver',
        'Canada/Pacific',
        'US/Pacific',
        'America/Anchorage',
        'America/Juneau',
        'America/Yakutat',
        'US/Alaska',
        'HST',
        'Pacific/Honolulu',
        'Pacific/Tahiti',
        'US/Hawaii',
        'Pacific/Samoa',
        'US/Samoa',
    ],

    minimalFontStyles: {
        "Arial, 'Helvetica Neue', Helvetica, sans-serif": 'Arial',
        "'Arial Black', 'Arial Bold', Arial, sans-serif": 'Arial Black',
        'Courier,serif': 'Courier',
        "'Courier New', Courier, 'Lucida Sans Typewriter', 'Lucida Typewriter', monospace": 'Courier New',
        "Georgia, Times, 'Times New Roman', serif": 'Georgia',
        'Tahoma, Verdana, sans-serif': 'Tahoma',
        "'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif": 'Trebuchet MS',
        "TimesNewRoman, 'Times New Roman', Times, Georgia, serif": 'Times New Roman',
        'Verdana, Geneva, sans-serif': 'Verdana',
    },

    fontStyles: {
        "Arial, 'Helvetica Neue', Helvetica, sans-serif": 'Arial',
        "'Arial Black', 'Arial Bold', Arial, sans-serif": 'Arial Black',
        "Arvo, 'Museo Slab', Rockwell, Basterville, 'Lucida Bright', serif": 'Arvo',
        'Bitter, Georgia, Palatino, serif': 'Bitter',
        "Cabin, Avenir, 'Trebuchet MS', 'Lucida Grande', Tahoma, sans-serif": 'Cabin',
        'Calibri, Candara, Arial, Helvetica, sans-serif': 'Calibri',
        "'Century Gothic', CenturyGothic, Arial, Helvetica, AppleGothic, Tahoma, sans-serif": 'Century Gothic',
        'Courier,serif': 'Courier',
        "'Courier New', Courier, 'Lucida Sans Typewriter', 'Lucida Typewriter', monospace": 'Courier New',
        "'Crete Round', 'PT Serif', Constantia, Bitter, Georgia, Palatino, serif": 'Crete Round',
        "'Droid Sans', Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif": 'Droid Sans',
        'futura-pt, sans-serif': 'Futura PT',
        "Garamond, Baskerville, 'Baskerville Old Face', 'Hoefler Text', 'Times New Roman', serif": 'Garamond',
        "Georgia, Times, 'Times New Roman', serif": 'Georgia',
        "Helvetica, 'Helvetica Neue', Arial, sans-serif": 'Helvetica',
        "Hind, Corbel, Lato, Tahoma, 'Trebuchet MS', sans-serif": 'Hind',
        "Karla,Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif": 'Karla',
        "Lato, Tahoma, 'Trebuchet MS', sans-serif": 'Lato',
        "Lora, Palatino, 'Book Antiqua', Georgia, serif": 'Lora',
        'Merriweather, Georgia, serif': 'Merriweather',
        "Montserrat, Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif": 'Montserrat',
        'Nunito, sans-serif': 'Nunito',
        "'Open Sans', 'Segoe UI', Tahoma, sans-serif": 'Open Sans',
        "Oswald, 'Impact', 'Franklin Gothic Bold', sans-serif": 'Oswald',
        "Palatino, 'Palatino Linotype', 'Palatino LT STD', 'Book Antiqua', Georgia, serif": 'Palatino',
        "'Playfair Display', Didot, 'Bodoni MT', 'Times New Roman', serif": 'Playfair Display',
        "'PT Sans', 'Open Sans', 'Segoe UI', Tahoma, sans-serif": 'PT Sans',
        "'PT Serif', Georgia, serif": 'PT Serif',
        "Raleway, Avenir, Lato, Tahoma, 'Trebuchet MS', sans-serif": 'Raleway',
        "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif": 'Roboto',
        "'Roboto Condensed', 'Arial Narrow', 'Avenir Next Condensed', Roboto, sans-serif": 'Roboto Condensed',
        "'Source Sans Pro', 'Open Sans', 'Segoe UI', Tahoma, sans-serif": 'Source Sans Pro',
        'Tahoma, Verdana, sans-serif': 'Tahoma',
        "'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif": 'Trebuchet MS',
        "TimesNewRoman, 'Times New Roman', Times, Georgia, serif": 'Times New Roman',
        'Verdana, Geneva, sans-serif': 'Verdana',
    },

    fontSizes: [
        '8px',
        '9px',
        '10px',
        '11px',
        '12px',
        '13px',
        '14px',
        '15px',
        '16px',
        '17px',
        '18px',
        '19px',
        '20px',
        '22px',
        '24px',
        '26px',
        '28px',
        '30px',
        '32px',
        '34px',
        '36px',
        '40px',
        '44px',
        '48px',
        '52px',
        '56px',
        '64px',
    ],

    getOpportunityBackgroundClass(color) {
        switch (color) {
            // Solids
            case 'Eris Solid':
                return 'eris-solid';

            case 'Begonia':
                return 'begonia';

            case 'Tangerine':
                return 'tangerine';

            case 'Lemon':
                return 'lemon';

            case 'Shire':
                return 'shire';

            case 'Lime Green':
                return 'lime-green';

            case 'Sea Foam':
                return 'sea-foam';

            case 'Deep Sky':
                return 'deep-sky-blue';

            case 'Andromeda':
                return 'andromeda';

            case 'Light Slate Purple':
                return 'light-slate-purple';

            case 'DOS':
                return 'dos';

            case 'Vivid Raspberry':
                return 'vivid-raspberry';

            // Gradients
            case 'Peachy Mango':
                return 'peachy-mango';

            case 'Sunrise':
                return 'sunrise';

            case 'Solar Wind':
                return 'solar-wind';

            case 'Flan':
                return 'flan';

            case 'Lemon Gradient':
                return 'lemon-gradient';

            case 'Citrus':
                return 'citrus';

            case 'Eldritch':
                return 'eldritch';

            case 'Mint':
                return 'mint';

            case 'Aquamarine':
                return 'aquamarine';

            case 'Cool Water':
                return 'cool-water';

            case 'Eris Gradient':
                return 'eris-gradient';

            case 'Rose Quartz':
                return 'rose-quartz';

            case 'Purple':
                return 'purple-gradient-bg';

            case 'Dark Blue':
                return 'dark-blue-gradient-bg';

            case 'Orange':
                return 'orange-gradient-bg';

            case 'Red':
                return 'red-gradient-bg';

            case 'Pink':
                return 'pink-gradient-bg';

            case 'Blue':
                return 'blue-gradient-bg';

            case 'Green':
                return 'green-gradient-bg';

            case 'Dark Cold Steel':
                return 'dark-cold-steel';

            default:
                return 'grey-gradient-bg';
        }
    },

    getContactStatusColorOptions() {
        return [
            {
                name: 'Eris Solid',
                className: 'eris-solid',
                type: 'solid',
            },
            {
                name: 'Begonia',
                className: 'begonia',
                type: 'solid',
            },
            {
                name: 'Tangerine',
                className: 'tangerine',
                type: 'solid',
            },
            {
                name: 'Lemon',
                className: 'lemon',
                type: 'solid',
            },
            {
                name: 'Shire',
                className: 'shire',
                type: 'solid',
            },
            {
                name: 'Lime Green',
                className: 'lime-green',
                type: 'solid',
            },
            {
                name: 'Sea Foam',
                className: 'sea-foam',
                type: 'solid',
            },
            {
                name: 'Deep Sky',
                className: 'deep-sky-blue',
                type: 'solid',
            },
            {
                name: 'Andromeda',
                className: 'andromeda',
                type: 'solid',
            },
            {
                name: 'Light Slate Purple',
                className: 'light-slate-purple',
                type: 'solid',
            },
            {
                name: 'DOS',
                className: 'dos',
                type: 'solid',
            },
            {
                name: 'Vivid Raspberry',
                className: 'vivid-raspberry',
                type: 'solid',
            },
            {
                name: 'Red',
                className: 'red-gradient-bg',
                type: 'gradient',
            },
            {
                name: 'Peachy Mango',
                className: 'peachy-mango',
                type: 'gradient',
            },
            {
                name: 'Sunrise',
                className: 'sunrise',
                type: 'gradient',
            },
            {
                name: 'Solar Wind',
                className: 'solar-wind',
                type: 'gradient',
            },
            {
                name: 'Flan',
                className: 'flan',
                type: 'gradient',
            },
            {
                name: 'Lemon Gradient',
                className: 'lemon-gradient',
                type: 'gradient',
            },
            {
                name: 'Citrus',
                className: 'citrus',
                type: 'gradient',
            },
            {
                name: 'Eldritch',
                className: 'eldritch',
                type: 'gradient',
            },
            {
                name: 'Mint',
                className: 'mint',
                type: 'gradient',
            },
            {
                name: 'Green',
                className: 'green-gradient-bg',
                type: 'gradient',
            },
            {
                name: 'Aquamarine',
                className: 'aquamarine',
                type: 'gradient',
            },
            {
                name: 'Cool Water',
                className: 'cool-water',
                type: 'gradient',
            },
            {
                name: 'Dark Blue',
                className: 'dark-blue-gradient-bg',
                type: 'gradient',
            },
            {
                name: 'Purple',
                className: 'purple-gradient-bg',
                type: 'gradient',
            },
            {
                name: 'Eris Gradient',
                className: 'eris-gradient',
                type: 'gradient',
            },
            {
                name: 'Rose Quartz',
                className: 'rose-quartz',
                type: 'gradient',
            },
            {
                name: 'Dark Cold Steel',
                className: 'dark-cold-steel',
                type: 'gradient',
            },
        ];
    },

    getContactStatusBackgroundClass(color) {
        switch (color) {
            // Solids
            case 'Eris Solid':
                return 'eris-solid';

            case 'Begonia':
                return 'begonia';

            case 'Tangerine':
                return 'tangerine';

            case 'Lemon':
                return 'lemon';

            case 'Shire':
                return 'shire';

            case 'Lime Green':
                return 'lime-green';

            case 'Sea Foam':
                return 'sea-foam';

            case 'Deep Sky':
                return 'deep-sky-blue';

            case 'Andromeda':
                return 'andromeda';

            case 'Light Slate Purple':
                return 'light-slate-purple';

            case 'DOS':
                return 'dos';

            case 'Vivid Raspberry':
                return 'vivid-raspberry';

            // Gradients
            case 'Peachy Mango':
                return 'peachy-mango';

            case 'Sunrise':
                return 'sunrise';

            case 'Solar Wind':
                return 'solar-wind';

            case 'Flan':
                return 'flan';

            case 'Lemon Gradient':
                return 'lemon-gradient';

            case 'Citrus':
                return 'citrus';

            case 'Eldritch':
                return 'eldritch';

            case 'Mint':
                return 'mint';

            case 'Aquamarine':
                return 'aquamarine';

            case 'Cool Water':
                return 'cool-water';

            case 'Eris Gradient':
                return 'eris-gradient';

            case 'Rose Quartz':
                return 'rose-quartz';

            case 'Purple':
                return 'purple-gradient-bg';

            case 'DarkBlue':
            case 'Dark Blue':
                return 'dark-blue-gradient-bg';

            case 'Orange':
                return 'orange-gradient-bg';

            case 'Red':
                return 'red-gradient-bg';

            case 'Pink':
                return 'pink-gradient-bg';

            case 'Blue':
                return 'blue-gradient-bg';

            case 'Green':
                return 'green-gradient-bg';

            case 'Grey':
                return 'grey-gradient-bg';

            case 'Dark Cold Steel':
                return 'dark-cold-steel';

            default:
                return 'dark-cold-steel';
        }
    },

    getOpportunityStatusColorNames(color) {
        switch (color) {
            case 'DarkBlue':
                return 'Dark Blue';
            case 'Orange':
                return 'Solar Wind';
            case 'Pink':
                return 'Rose Quartz';
            case 'Blue':
                return 'Aquamarine';
            case 'Grey':
                return 'Dark Cold Steel';
            default:
                return color;
        }
    },

    getFilenameWithoutExtension(filename, extension) {
        if (extension) {
            var nameParts = (filename || '').split('.');
            var possibleExtension = nameParts[nameParts.length - 1];

            var hasExtension = possibleExtension.toUpperCase() === extension.toUpperCase();
            if (hasExtension) {
                return nameParts.splice(0, nameParts.length - 1).join('.');
            }
        }

        return filename;
    },

    getDomainFromUrl(url) {
        var hostname;

        // find & remove protocol (http, ftp, etc.) and get hostname
        if (url.indexOf('://') > -1) {
            hostname = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
        } else {
            hostname = url.match(/(www[0-9]?\.)?(.[^/:]+)/i);
        }

        if (hostname != null && hostname.length > 2 && typeof hostname[2] === 'string' && hostname[2].length > 0) {
            return psl.parse(hostname[2]).domain;
        } else {
            return null;
        }
    },

    showNotification(message) {
        EventBus.$emit('show-notification', {
            iconUrl: null,
            isIconSvg: false,
            message: message,
            actionLabel: null,
            action: () => ({})
        })
    },

    showSuccessNotification(message) {
        EventBus.$emit('show-notification', {
            iconUrl: require('@/assets/images/SVG/checkmark.svg'),
            isIconSvg: true,
            message: message,
            actionLabel: null,
            action: () => {},
        });
    },

    showFailNotification(message, {level = LogLevel.ERROR, error = null, enable = true,} = {}) {
        if (enable) {
            EventBus.$emit('show-notification', {
                iconUrl: require('@/assets/images/SVG/alert.svg'),
                type: 'fail',
                isIconSvg: true,
                message: message,
                actionLabel: null,
                action: () => {
                },
            });
        }
        if (error) {
            log.withLevel(level, message, error);
        } else {
            log.withLevel(level, message);
        }
    },

    createBrandingOptions(accountSettings) {
        var brandingOptions = [];

        brandingOptions.push({
            name: 'Background Color',
            key: '[BackgroundColor]',
            color: accountSettings.backgroundColor,
        });

        brandingOptions.push({
            name: 'Background Font Color',
            key: '[BackgroundFontColor]',
            color: accountSettings.backgroundFontColor,
        });

        brandingOptions.push({
            name: 'Primary Color',
            key: '[PrimaryColor]',
            color: accountSettings.primaryColor,
        });

        brandingOptions.push({
            name: 'Primary Font Color',
            key: '[PrimaryFontColor]',
            color: accountSettings.primaryFontColor,
        });

        brandingOptions.push({
            name: 'Secondary Color',
            key: '[SecondaryColor]',
            color: accountSettings.secondaryColor,
        });

        brandingOptions.push({
            name: 'Secondary Font Color',
            key: '[SecondaryFontColor]',
            color: accountSettings.secondaryFontColor,
        });

        brandingOptions.push({
            name: 'Canvas Color',
            key: '[CanvasColor]',
            color: accountSettings.canvasColor,
        });

        brandingOptions.push({
            name: 'Canvas Font Color',
            key: '[CanvasFontColor]',
            color: accountSettings.canvasFontColor,
        });

        brandingOptions.push({
            name: 'Button Color',
            key: '[ButtonColor]',
            color: accountSettings.buttonColor,
        });

        brandingOptions.push({
            name: 'Button Font Color',
            key: '[ButtonFontColor]',
            color: accountSettings.buttonFontColor,
        });

        return brandingOptions;
    },

    getBrandingFromClient(client) {
        var brandingOptions = [];
        brandingOptions.push({
            name: 'Background Color',
            key: '[BackgroundColor]',
            color: client.TemplateBackgroundColor,
        });

        brandingOptions.push({
            name: 'Background Font Color',
            key: '[BackgroundFontColor]',
            color: client.TemplateBackgroundFontColor,
        });

        brandingOptions.push({
            name: 'Primary Color',
            key: '[PrimaryColor]',
            color: client.TemplatePrimaryColor,
        });

        brandingOptions.push({
            name: 'Primary Font Color',
            key: '[PrimaryFontColor]',
            color: client.TemplatePrimaryFontColor,
        });

        brandingOptions.push({
            name: 'Secondary Color',
            key: '[SecondaryColor]',
            color: client.TemplateSecondaryColor,
        });

        brandingOptions.push({
            name: 'Secondary Font Color',
            key: '[SecondaryFontColor]',
            color: client.TemplateSecondaryFontColor,
        });

        brandingOptions.push({
            name: 'Canvas Color',
            key: '[CanvasColor]',
            color: client.TemplateCanvasColor,
        });

        brandingOptions.push({
            name: 'Canvas Font Color',
            key: '[CanvasFontColor]',
            color: client.TemplateCanvasFontColor,
        });

        brandingOptions.push({
            name: 'Button Color',
            key: '[ButtonColor]',
            color: client.TemplateButtonColor,
        });

        brandingOptions.push({
            name: 'Button Font Color',
            key: '[ButtonFontColor]',
            color: client.TemplateButtonFontColor,
        });

        return brandingOptions;
    },

    getBrandingFromClientContext(client) {
        var brandingOptions = [];

        brandingOptions.push({
            name: 'Background Color',
            key: '[BackgroundColor]',
            color: client.templateBackgroundColor,
        });

        brandingOptions.push({
            name: 'Background Font Color',
            key: '[BackgroundFontColor]',
            color: client.templateBackgroundFontColor,
        });

        brandingOptions.push({
            name: 'Primary Color',
            key: '[PrimaryColor]',
            color: client.templatePrimaryColor,
        });

        brandingOptions.push({
            name: 'Primary Font Color',
            key: '[PrimaryFontColor]',
            color: client.templatePrimaryFontColor,
        });

        brandingOptions.push({
            name: 'Secondary Color',
            key: '[SecondaryColor]',
            color: client.templateSecondaryColor,
        });

        brandingOptions.push({
            name: 'Secondary Font Color',
            key: '[SecondaryFontColor]',
            color: client.templateSecondaryFontColor,
        });

        brandingOptions.push({
            name: 'Canvas Color',
            key: '[CanvasColor]',
            color: client.templateCanvasColor,
        });

        brandingOptions.push({
            name: 'Canvas Font Color',
            key: '[CanvasFontColor]',
            color: client.templateCanvasFontColor,
        });

        brandingOptions.push({
            name: 'Button Color',
            key: '[ButtonColor]',
            color: client.templateButtonColor,
        });

        brandingOptions.push({
            name: 'Button Font Color',
            key: '[ButtonFontColor]',
            color: client.templateButtonFontColor,
        });

        return brandingOptions;
    },

    parseConfiguration(configuration, isPlain, client) {
        var parsedConfiguration = JSON.parse(configuration);

        if (!isPlain && configuration) {
            parsedConfiguration = this.patchConfiguration(parsedConfiguration, client);
        }

        return parsedConfiguration;
    },

    patchConfiguration(configuration, client) {
        if (!configuration.global) {
            configuration = this.getDefaultGraphicalConfiguration();
        }

        if (!configuration.global.classes.link) {
            configuration.global.classes.link = {
                color: {
                    value: '#000000',
                    type: 'custom',
                    branding: null,
                },
            };
        }

        configuration.global.classes.h1.color = this.getPatchedColorConfiguration(
            configuration.global.classes.h1.color
        );
        configuration.global.classes.h2.color = this.getPatchedColorConfiguration(
            configuration.global.classes.h2.color
        );
        configuration.global.classes.h3.color = this.getPatchedColorConfiguration(
            configuration.global.classes.h3.color
        );
        configuration.global.classes.normal.color = this.getPatchedColorConfiguration(
            configuration.global.classes.normal.color
        );
        configuration.global.classes.email.color = this.getPatchedColorConfiguration(
            configuration.global.classes.email.color
        );
        configuration.global.classes.link.color = this.getPatchedColorConfiguration(
            configuration.global.classes.link.color
        );
        configuration.global.classes.button.color = this.getPatchedColorConfiguration(
            configuration.global.classes.button.color
        );
        configuration.global.classes.button.backgroundColor = this.getPatchedColorConfiguration(
            configuration.global.classes.button.backgroundColor
        );
        configuration.global.sectionBackground = this.getPatchedColorConfiguration(
            configuration.global.sectionBackground
        );
        configuration.global.canvasBackground = this.getPatchedColorConfiguration(
            configuration.global.canvasBackground
        );
        configuration.global.emailBackground = this.getPatchedColorConfiguration(configuration.global.emailBackground);

        for (var i = 0; i < configuration.sections.length; i++) {
            var section = configuration.sections[i];
            section.values.backgroundColor = this.getPatchedColorConfiguration(section.values.backgroundColor);

            if (!section.values.bottomSpacing) {
                section.values.bottomSpacing = 0;
            }

            for (var j = 0; j < section.columns.length; j++) {
                var column = section.columns[j];
                for (var k = 0; k < column.elements.length; k++) {
                    var element = column.elements[k];
                    if (element.name === 'divider') {
                        element.styles.backgroundColor = this.getPatchedColorConfiguration(
                            element.styles.backgroundColor
                        );
                    } else if (element.name === 'button') {
                        element.styles.backgroundColor = this.getPatchedColorConfiguration(
                            element.styles.backgroundColor
                        );
                        element.styles.color = this.getPatchedColorConfiguration(element.styles.color);
                    } else if (element.name === 'text') {
                        if (element.values && element.values.value) {
                            this.processColorBranding(element, client);
                        }
                    }
                }
            }
        }

        return configuration;
    },

    getPatchedColorConfiguration(color) {
        var newColor = color;

        if (typeof color === 'string') {
            var isKey = color.match(/\[.*?\]/);
            if (isKey) {
                newColor = {
                    value: null,
                    type: 'branded',
                    branding: color,
                };
            } else {
                newColor = {
                    value: color,
                    type: 'custom',
                    branding: null,
                };
            }
        }

        return newColor;
    },

    getDefaultPlainConfiguration() {
        return {
            body: '',
        };
    },

    getDefaultGraphicalConfiguration() {
        return {
            global: {
                classes: {
                    h1: {
                        fontSize: '36px',
                        fontStyle: "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                        color: {
                            value: '#000000',
                            type: 'custom',
                            branding: null,
                        },
                    },
                    h2: {
                        fontSize: '24px',
                        fontStyle: "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                        color: {
                            value: '#000000',
                            type: 'custom',
                            branding: null,
                        },
                    },
                    h3: {
                        fontSize: '18px',
                        fontStyle: "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                        color: {
                            value: '#000000',
                            type: 'custom',
                            branding: null,
                        },
                    },
                    normal: {
                        fontSize: '16px',
                        fontStyle: "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                        color: {
                            value: '#000000',
                            type: 'custom',
                            branding: null,
                        },
                    },
                    email: {
                        fontStyle: "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                        color: {
                            value: '#000000',
                            type: 'custom',
                            branding: null,
                        },
                    },
                    link: {
                        color: {
                            value: '#000000',
                            type: 'custom',
                            branding: null,
                        },
                    },
                    button: {
                        backgroundColor: {
                            value: '#30b1f2',
                            type: 'custom',
                            branding: null,
                        },
                        color: {
                            value: '#FFFFFF',
                            type: 'custom',
                            branding: null,
                        },
                    },
                },
                sectionBackground: {
                    value: 'transparent',
                    type: 'custom',
                    branding: null,
                },
                canvasBackground: {
                    value: '#FFFFFF',
                    type: 'custom',
                    branding: null,
                },
                emailBackground: {
                    value: '#DDE6F0',
                    type: 'custom',
                    branding: null,
                },
            },
            preheader: {
                value: 'Preheader text goes here',
                showViewInBrowserLink: true,
            },
            logo: {
                text: {
                    value: '',
                    fontStyle: "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                    align: 'center',
                    link: '',
                },
                image: {
                    url: '',
                    align: 'center',
                    height: null,
                    width: null,
                    altText: '',
                    link: '',
                    zoom: 1,
                },
                topSpace: 0,
                bottomSpace: 0,
                type: 'image',
            },
            sections: [],
            footer: {
                value: 'Your Company Name and Address Here',
            },
        };
    },

    processColorBranding(unprocessedElement, client) {
        var branding = null;

        if (client) {
            branding = this.getBrandingFromClient(client);
        } else {
            branding = this.getDefaultBranding();
        }

        var el = document.createElement('span');
        el.innerHTML = unprocessedElement.values.value;

        for (var i = 0; i < branding.length; i++) {
            var selector = `[data-branding='${branding[i].key}']`;
            var elements = el.querySelectorAll(selector);

            if (elements.length > 0) {
                for (var j = 0; j < elements.length; j++) {
                    el.querySelectorAll(selector)[j].style.color = branding[i].color;
                }
            }
        }

        unprocessedElement.values.value = el.innerHTML;
    },

    getDefaultBranding() {
        var branding = [];

        branding.push({
            name: 'Background Color',
            key: '[BackgroundColor]',
            color: '#d8e2ee',
        });

        branding.push({
            name: 'Background Font Color',
            key: '[BackgroundFontColor]',
            color: '#141414',
        });

        branding.push({
            name: 'Primary Color',
            key: '[PrimaryColor]',
            color: '#000fb9',
        });

        branding.push({
            name: 'Primary Font Color',
            key: '[PrimaryFontColor]',
            color: '#ffffff',
        });

        branding.push({
            name: 'Secondary Color',
            key: '[SecondaryColor]',
            color: '#d5d5d5',
        });

        branding.push({
            name: 'Secondary Font Color',
            key: '[SecondaryFontColor]',
            color: '#212529',
        });

        branding.push({
            name: 'Canvas Color',
            key: '[CanvasColor]',
            color: '#ffffff',
        });

        branding.push({
            name: 'Canvas Font Color',
            key: '[CanvasFontColor]',
            color: '#000000',
        });

        branding.push({
            name: 'Button Color',
            key: '[ButtonColor]',
            color: '#ed7e33',
        });

        branding.push({
            name: 'Button Font Color',
            key: '[ButtonFontColor]',
            color: '#ffffff',
        });

        return branding;
    },

    getDefaultCollateralBrandingOptions() {
        var options = [];

        options.push({
            name: 'Paper Color',
            key: '[PaperColor]',
            color: '#FFFFFF',
        });

        options.push({
            name: 'Primary Color',
            key: '[PrimaryColor]',
            color: '#F30070',
        });

        options.push({
            name: 'Accent Color',
            key: '[AccentColor]',
            color: '#EB7E0A',
        });

        options.push({
            name: 'Secondary Color',
            key: '[SecondaryColor]',
            color: '#8274E8',
        });

        options.push({
            name: 'Body Color',
            key: '[BodyColor]',
            color: '#382153',
        });

        options.push({
            name: 'Link Color',
            key: '[LinkColor]',
            color: '#18AEFF',
        });

        options.push({
            name: 'Pagination Color',
            key: '[PaginationColor]',
            color: '#FFFFFF',
        });

        options.push({
            name: 'Heading 1',
            key: '[Heading1Color]',
            color: '#f30071',
        });

        options.push({
            name: 'Heading 2',
            key: '[Heading2Color]',
            color: '#EB7E0A',
        });

        options.push({
            name: 'Heading 3',
            key: '[Heading3Color]',
            color: '#877D88',
        });

        options.push({
            name: 'Heading 4',
            key: '[Heading4Color]',
            color: '#382153',
        });

        options.push({
            name: 'Heading 5',
            key: '[Heading5Color]',
            color: '#382153',
        });

        options.push({
            name: 'Heading 6',
            key: '[Heading6Color]',
            color: '#382153',
        });

        options.push({
            name: 'Button Text Color',
            key: '[ButtonTextColor]',
            color: '#382153',
        });

        options.push({
            name: 'Button Color',
            key: '[ButtonColor]',
            color: '#F30070',
        });

        options.push({
            name: 'Button Stroke',
            key: '[ButtonStrokeColor]',
            color: '#18AEFF',
        });

        return options;
    },

    convertBytesToKiloBytes(bytes) {
        var kiloBytes = 0;

        kiloBytes = bytes / 1000;
        kiloBytes = kiloBytes.toFixed(2);

        var splitSize = kiloBytes.split('.');

        if (splitSize[0] == 0) {
            return '0.' + splitSize[1] + 'KB';
        } else {
            return kiloBytes + 'KB';
        }
    },

    convertbytesToLargestUnit(bytes) {
        const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];

        if (bytes === 0) {
            return 'n/a';
        }

        const i = parseInt(Math.floor(Math.log(Math.abs(bytes)) / Math.log(1024)), 10);

        if (i === 0) {
            return `${bytes} ${sizes[i]}`;
        }
        return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`;
    },

    isInView(element, tolerance = 0) {
        if (element) {
            var isInView = false;

            var boundingRectangle = element.getBoundingClientRect();
            var viewportOffeset = boundingRectangle.top;

            var windowHeight = window.innerHeight;
            var headerHeight = document.querySelector('.header-module').offsetHeight;
            var bodyViewport = windowHeight - headerHeight;

            if (viewportOffeset <= bodyViewport - tolerance) {
                isInView = true;
            }

            return isInView;
        }
    },

    createGuid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }

        return s4() + s4() + s4() + s4();
    },

    createId(prefix) {
        return `${prefix}-${this.createGuid()}`;
    },

    addHttpToUrl(url) {
        if (url && !url.includes('http://') && !url.includes('https://')) {
            return `http://${url}`;
        }

        return url;
    },

    addHttpsToUrl(url) {
        if (url && !url.includes('http://') && !url.includes('https://')) {
            return `https://${url}`;
        }

        return url;    
    },

    addHttpToLinks(config) {
        if (config && config.sections) {
            var sections = config.sections;
            sections.forEach((section) => {
                if (section.columns) {
                    section.columns.forEach((column) => {
                        if (column.elements) {
                            column.elements.forEach((element) => {
                                if (element.label === 'Button' || element.label === 'Image') {
                                    if (
                                        !element.values.link.includes('http://') &&
                                        !element.values.link.includes('https://')
                                    ) {
                                        if (element.values.link !== '#' && element.values.link !== '') {
                                            element.values.link = `http://${element.values.link}`;
                                        }
                                    }
                                }
                                if (element.label === 'Media') {
                                    var socialMedias = ['facebook','instagram','linkedin', 'twitter', 'website', 'youtube']

                                    socialMedias.forEach(m => {
                                        if (
                                            !element.values[m].url.includes('http://') &&
                                            !element.values[m].url.includes('https://')
                                        ) {
                                            if (element.values[m].url !== '#' && element.values[m].url !== '') {
                                                element.values[m].url = `https://${element.values[m].url}`;
                                            }
                                        }
    
                                    })
                                }
                            });
                        }
                    });
                }
            });
        }
    },

    groupDataByMonthAndYear(data, datePropertyName, secondaryDateProperty, ascending) {
        if (datePropertyName) {
            var years = {};

            data.forEach((element) => {
                var date = this.getGroupedElementDate(element, datePropertyName, secondaryDateProperty);
                var year = date.year();
                var month = date.month();

                if (!years[year]) {
                    years[year] = {
                        name: String(moment().year(year).format('YYYY')),
                        months: {},
                    };
                }

                if (date) {
                    if (typeof date === 'string') {
                        date = moment(date);
                    }

                    year = date.year();
                    month = date.month();

                    if (!years[year]) {
                        years[year] = {
                            name: String(moment().year(year).format('YYYY')),
                            months: {},
                        };
                    }

                    if (!years[year]['months'][month]) {
                        years[year]['months'][month] = {
                            name: String(moment().month(month).format('MMMM')),
                            data: [],
                            isDataShown: true,
                        };
                    }

                    years[year]['months'][month].data.push(element);
                }
            });

            years = Object.values(years).map((y) => {
                var months = Object.values(y.months);
                months.forEach((month) => (month.data ? month.data : null));

                var year = {
                    name: y.name,
                    months: months,
                };

                if (!ascending) {
                    year.months.reverse();
                }

                return year;
            });

            if (!ascending) {
                years.reverse();
            }

            return years;
        }
    },

    getGroupedElementDate(element, datePropertyName, secondaryDateProperty) {
        var date = element[datePropertyName];

        if (!date) {
            date = element[secondaryDateProperty];
            if (typeof element[secondaryDateProperty] === 'string') {
                date = moment(date);
            } else if (element[secondaryDateProperty] instanceof Date) {
                date = moment(date);
            }
        } else {
            if (typeof element[datePropertyName] === 'string') {
                date = moment(date);
            } else if (element[datePropertyName] instanceof Date) {
                date = moment(date);
            }
        }

        return date;
    },

    parseTaskTypeValue(value) {
        if (Number.isInteger(value)) {
            switch (value) {
                case 1:
                    return 'Call';
                case 2:
                    return 'Email';
                case 3:
                    return 'Meeting';
                case 4:
                    return 'Note';
                case 5:
                    return 'General';
                default:
                    break;
            }
        } else {
            switch (value.toUpperCase()) {
                case 'CALL':
                    return 1;
                case 'EMAIL':
                    return 2;
                case 'MEETING':
                    return 3;
                case 'NOTE':
                    return 4;
                case 'GENERAL':
                    return 5;
                default:
                    break;
            }
        }
    },

    fallbackCopyTextToClipboard(text) {
        var textArea = document.createElement('textarea');
        textArea.value = text;

        // Avoid scrolling to bottom
        textArea.style.top = '0';
        textArea.style.left = '0';
        textArea.style.position = 'fixed';

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            var successful = document.execCommand('copy');

            if (successful) {
                helpers.showSuccessNotification('Copied!');
            } else {
                helpers.showFailNotification('Failed to copy.', { level: LogLevel.INFO });
            }
        } catch (error) {
            helpers.showFailNotification('Failed to copy.', { error });
        }

        document.body.removeChild(textArea);
    },

    copyTextToClipboard(text) {
        if (!navigator.clipboard) {
            helpers.fallbackCopyTextToClipboard(text);
            return;
        }

        navigator.clipboard.writeText(text).then(
            () => {
                helpers.showSuccessNotification('Copied!');
            },
            () => {
                helpers.showFailNotification('Failed to copy.', { level: LogLevel.INFO });
            }
        );
    },

    setPopupWidth() {
        return 830;
    },

    setPopupHeight() {
        return 'auto';
    },

    getDefaultCollateralBranding() {
        return {
            image: {
                name: null,
                src: null,
            },
            lightImage: {
                name: null,
                src: null,
            },
            backgroundColor: {
                branding: null,
                enabled: true,
                type: null,
                value: '#FFFFFF',
            },
            primaryColor: {
                branding: null,
                enabled: true,
                type: null,
                value: '#F30070',
            },
            accentColor: {
                branding: null,
                enabled: true,
                type: null,
                value: '#EB7E0A',
            },
            secondaryColor: {
                branding: null,
                enabled: true,
                type: null,
                value: '#8274E8',
            },
            text: {
                color: {
                    branding: null,
                    enabled: true,
                    type: null,
                    value: '#382153',
                },
                fontSize: 14,
                fontFamily: {
                    key: 'Roboto',
                    value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`,
                },
            },
            linkColor: {
                branding: null,
                enabled: true,
                type: null,
                value: '#18AEFF',
            },

            pagination: {
                color: {
                    branding: null,
                    enabled: true,
                    type: null,
                    value: '#FFFFFF',
                },
                fontSize: 20,
                fontFamily: {
                    key: 'Roboto',
                    value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`,
                },
            },
            heading1: {
                color: {
                    branding: null,
                    enabled: true,
                    type: null,
                    value: '#f30071',
                },
                fontSize: 52,
                fontFamily: {
                    key: 'Roboto',
                    value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`,
                },
            },
            heading2: {
                color: {
                    branding: null,
                    enabled: true,
                    type: null,
                    value: '#EB7E0A',
                },
                fontSize: 27,
                fontFamily: {
                    key: 'Roboto',
                    value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`,
                },
            },
            heading3: {
                color: {
                    branding: null,
                    enabled: true,
                    type: null,
                    value: '#877D88',
                },
                fontSize: 24,
                fontFamily: {
                    key: 'Roboto',
                    value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`,
                },
            },
            heading4: {
                color: {
                    branding: null,
                    enabled: true,
                    type: null,
                    value: '#382153',
                },
                fontSize: 18,
                fontFamily: {
                    key: 'Roboto',
                    value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`,
                },
            },
            heading5: {
                color: {
                    branding: null,
                    enabled: true,
                    type: null,
                    value: '#382153',
                },
                fontSize: 18,
                fontFamily: {
                    key: 'Roboto',
                    value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`,
                },
            },
            heading6: {
                color: {
                    branding: null,
                    enabled: true,
                    type: null,
                    value: '#382153',
                },
                fontSize: 18,
                fontFamily: {
                    key: 'Roboto',
                    value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`,
                },
            },
            button: {
                textColor: {
                    branding: null,
                    enabled: true,
                    type: null,
                    value: '#FFFFFF',
                },
                backgroundColor: {
                    branding: null,
                    enabled: true,
                    type: null,
                    value: '#F30070',
                },
                borderColor: {
                    branding: null,
                    enabled: true,
                    type: null,
                    value: '#18AEFF',
                },
                fontSize: 18,
                fontFamily: {
                    key: 'Roboto',
                    value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`,
                },
                borderRadius: 'none',
            },
            companyDetails: {
                name: null,
                address: null,
                website: null,
            },
        };
    },

    createLandingPageBrandingOptions(landingPageBrandingConfig) {
        return [
            {
                name: 'Background Color',
                key: '[BackgroundColor]',
                color: landingPageBrandingConfig.backgroundColor.value,
            },
            {
                name: 'Primary Color',
                key: '[PrimaryColor]',
                color: landingPageBrandingConfig.primaryColor.value,
            },
            {
                name: 'Accent Color',
                key: '[AccentColor]',
                color: landingPageBrandingConfig.accentColor.value,
            },
            {
                name: 'Secondary Color',
                key: '[SecondaryColor]',
                color: landingPageBrandingConfig.secondaryColor.value,
            },
            {
                name: 'Text Color',
                key: '[TextColor]',
                color: landingPageBrandingConfig.text.color.value,
            },
            {
                name: 'Heading 1',
                key: '[Heading1Color]',
                color: landingPageBrandingConfig.heading1.color.value,
            },
            {
                name: 'Heading 2',
                key: '[Heading2Color]',
                color: landingPageBrandingConfig.heading2.color.value,
            },
            {
                name: 'Heading 3',
                key: '[Heading3Color]',
                color: landingPageBrandingConfig.heading3.color.value,
            },
            {
                name: 'Heading 4',
                key: '[Heading4Color]',
                color: landingPageBrandingConfig.heading4.color.value,
            },
            {
                name: 'Heading 5',
                key: '[Heading5Color]',
                color: landingPageBrandingConfig.heading5.color.value,
            },
            {
                name: 'Heading 6',
                key: '[Heading6Color]',
                color: landingPageBrandingConfig.heading6.color.value,
            },
            {
                name: 'Button Text',
                key: '[ButtonTextColor]',
                color: landingPageBrandingConfig.button.textColor.value,
            },
            {
                name: 'Button Background',
                key: '[ButtonBackgroundColor]',
                color: landingPageBrandingConfig.button.buttonColor.value,
            },
            {
                name: 'Button Text Color',
                key: '[ButtonTextColor]',
                color: landingPageBrandingConfig.button.textColor.value,
            },
            {
                name: 'Bullets Color',
                key: '[BulletsColor]',
                color: landingPageBrandingConfig.bulletsColor.value,
            },
        ];
    },

    getDefaultLandingPageBrandingOptions() {
        const defaultBrandingConfig = this.getDefaultLandingPageBranding();
        return this.createLandingPageBrandingOptions(defaultBrandingConfig);
    },

    getDefaultLandingPageBranding() {
        return {
            image: {
                name: null,
                src: null,
            },
            lightImage: {
                name: null,
                src: null,
            },
            backgroundColor: {
                branding: null,
                enabled: true,
                type: null,
                value: '#FFFFFF',
            },
            primaryColor: {
                branding: null,
                enabled: true,
                type: null,
                value: '#F30070',
            },
            accentColor: {
                branding: null,
                enabled: true,
                type: null,
                value: '#EB7E0A',
            },
            secondaryColor: {
                branding: null,
                enabled: true,
                type: null,
                value: '#8274E8',
            },
            text: {
                color: {
                    branding: null,
                    enabled: true,
                    type: null,
                    value: '#382153',
                },
                fontSize: 16,
                fontFamily: {
                    key: 'Roboto',
                    value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`,
                },
            },
            links: {
                color: { branding: null, enabled: true, type: null, value: '#18AEFF' },
                hoverColor: { branding: null, enabled: true, type: null, value: '#5052FE' },
                visitedColor: { branding: null, enabled: true, type: null, value: '#5052FE' },
                fontSize: 16,
                fontFamily: {
                    key: 'Roboto',
                    value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`,
                },
            },
            heading1: {
                color: {
                    branding: null,
                    enabled: true,
                    type: null,
                    value: '#7A5BFF',
                },
                fontSize: 30,
                fontFamily: {
                    key: 'Roboto',
                    value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`,
                },
            },
            heading2: {
                color: {
                    branding: null,
                    enabled: true,
                    type: null,
                    value: '#7A5BFF',
                },
                fontSize: 25,
                fontFamily: {
                    key: 'Roboto',
                    value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`,
                },
            },
            heading3: {
                color: {
                    branding: null,
                    enabled: true,
                    type: null,
                    value: '#7A5BFF',
                },
                fontSize: 22,
                fontFamily: {
                    key: 'Roboto',
                    value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`,
                },
            },
            heading4: {
                color: {
                    branding: null,
                    enabled: true,
                    type: null,
                    value: '#382153',
                },
                fontSize: 20,
                fontFamily: {
                    key: 'Roboto',
                    value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`,
                },
            },
            heading5: {
                color: {
                    branding: null,
                    enabled: true,
                    type: null,
                    value: '#F30070',
                },
                fontSize: 18,
                fontFamily: {
                    key: 'Roboto',
                    value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`,
                },
            },
            heading6: {
                color: {
                    branding: null,
                    enabled: true,
                    type: null,
                    value: '#382153',
                },
                fontSize: 16,
                fontFamily: {
                    key: 'Roboto',
                    value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`,
                },
            },
            button: {
                textColor: {
                    branding: null,
                    enabled: true,
                    type: null,
                    value: '#FFFFFF',
                },
                buttonColor: {
                    branding: null,
                    enabled: true,
                    type: null,
                    value: '#18AEFF',
                },
                fill: 'solid',
                fontSize: 14,
                fontFamily: {
                    key: 'Roboto',
                    value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`,
                },
                borderRadius: 'large',
            },
            bulletsColor: {
                branding: null,
                enabled: true,
                type: null,
                value: '#EE206F',
            },
        };
    },

    createDocumentBrandingOptions(documentBrandingConfig) {
        return [
            {
                name: 'Background Color',
                key: '[BackgroundColor]',
                color: documentBrandingConfig.backgroundColor.value,
            },
            {
                name: 'Primary Color',
                key: '[PrimaryColor]',
                color: documentBrandingConfig.primaryColor.value,
            },
            {
                name: 'Accent Color',
                key: '[AccentColor]',
                color: documentBrandingConfig.accentColor.value,
            },
            {
                name: 'Secondary Color',
                key: '[SecondaryColor]',
                color: documentBrandingConfig.secondaryColor.value,
            },
            {
                name: 'Text Color',
                key: '[TextColor]',
                color: documentBrandingConfig.text.color.value,
            },
            {
                name: 'Heading 1',
                key: '[Heading1Color]',
                color: documentBrandingConfig.heading1.color.value,
            },
            {
                name: 'Heading 2',
                key: '[Heading2Color]',
                color: documentBrandingConfig.heading2.color.value,
            },
            {
                name: 'Heading 3',
                key: '[Heading3Color]',
                color: documentBrandingConfig.heading3.color.value,
            },
            {
                name: 'Heading 4',
                key: '[Heading4Color]',
                color: documentBrandingConfig.heading4.color.value,
            },
            {
                name: 'Heading 5',
                key: '[Heading5Color]',
                color: documentBrandingConfig.heading5.color.value,
            },
            {
                name: 'Heading 6',
                key: '[Heading6Color]',
                color: documentBrandingConfig.heading6.color.value,
            },
            {
                name: 'Button Text',
                key: '[ButtonTextColor]',
                color: documentBrandingConfig.button.textColor.value,
            },
            {
                name: 'Button Background',
                key: '[ButtonBackgroundColor]',
                color: documentBrandingConfig.button.buttonColor.value,
            },
            {
                name: 'Bullets Color',
                key: '[BulletsColor]',
                color: documentBrandingConfig.bulletsColor.value,
            },
            {
                name: 'Link Color',
                key: '[LinkColor]',
                color: documentBrandingConfig.links.color.value,
            },
            {
                name: 'Link Hover Color',
                key: '[LinkHoverColor]',
                color: documentBrandingConfig.links.hoverColor.value,
            },
            {
                name: 'Link Visit Color',
                key: '[LinkVisitColor]',
                color: documentBrandingConfig.links.visitedColor.value,
            },
        ];
    },

    createDocumentLogoBrandingOptions(documentBrandingConfig) {
        return [
            {
                name: 'Dark Logo',
                key: '[DarkLogo]',
                imgName: documentBrandingConfig.image.name || null,
                src: documentBrandingConfig.image.src || null,
            },
            {
                name: 'Light Logo',
                key: '[LightLogo]',
                imgName: documentBrandingConfig.lightImage.name || null,
                src: documentBrandingConfig.lightImage.src || null,
            },

        ]
    },

    getDefaultDocumentBrandingOptions() {
        const defaultBrandingConfig = this.getDefaultDocumentBranding();
        return this.createDocumentBrandingOptions(defaultBrandingConfig);
    },

    getDefaultDocumentLogoBrandingOptions() {
        const defaultBrandingConfig = this.getDefaultDocumentBranding();
        return this.createDocumentLogoBrandingOptions(defaultBrandingConfig);
    },

    getDefaultDocumentBranding() {
        return {
            companyName: '',
            image: {
                name: null,
                src: null,
            },
            lightImage: {
                name: null,
                src: null,
            },
            backgroundColor: {
                branding: null,
                enabled: true,
                type: null,
                value: '#FFFFFF',
            },
            primaryColor: {
                branding: null,
                enabled: true,
                type: null,
                value: '#F30070',
            },
            accentColor: {
                branding: null,
                enabled: true,
                type: null,
                value: '#EB7E0A',
            },
            secondaryColor: {
                branding: null,
                enabled: true,
                type: null,
                value: '#8274E8',
            },
            text: {
                color: {
                    branding: null,
                    enabled: true,
                    type: null,
                    value: '#382153',
                },
                fontSize: 16,
                fontFamily: {
                    key: 'Roboto',
                    value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`,
                },
            },
            links: {
                color: { branding: null, enabled: true, type: null, value: '#18AEFF' },
                hoverColor: { branding: null, enabled: true, type: null, value: '#5052FE' },
                visitedColor: { branding: null, enabled: true, type: null, value: '#5052FE' },
                fontSize: 16,
                fontFamily: {
                    key: 'Roboto',
                    value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`,
                },
            },
            heading1: {
                color: {
                    branding: null,
                    enabled: true,
                    type: null,
                    value: '#7A5BFF',
                },
                fontSize: 30,
                fontFamily: {
                    key: 'Roboto',
                    value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`,
                },
            },
            heading2: {
                color: {
                    branding: null,
                    enabled: true,
                    type: null,
                    value: '#7A5BFF',
                },
                fontSize: 25,
                fontFamily: {
                    key: 'Roboto',
                    value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`,
                },
            },
            heading3: {
                color: {
                    branding: null,
                    enabled: true,
                    type: null,
                    value: '#7A5BFF',
                },
                fontSize: 22,
                fontFamily: {
                    key: 'Roboto',
                    value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`,
                },
            },
            heading4: {
                color: {
                    branding: null,
                    enabled: true,
                    type: null,
                    value: '#382153',
                },
                fontSize: 20,
                fontFamily: {
                    key: 'Roboto',
                    value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`,
                },
            },
            heading5: {
                color: {
                    branding: null,
                    enabled: true,
                    type: null,
                    value: '#F30070',
                },
                fontSize: 18,
                fontFamily: {
                    key: 'Roboto',
                    value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`,
                },
            },
            heading6: {
                color: {
                    branding: null,
                    enabled: true,
                    type: null,
                    value: '#382153',
                },
                fontSize: 16,
                fontFamily: {
                    key: 'Roboto',
                    value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`,
                },
            },
            button: {
                textColor: {
                    branding: null,
                    enabled: true,
                    type: null,
                    value: '#FFFFFF',
                },
                buttonColor: {
                    branding: null,
                    enabled: true,
                    type: null,
                    value: '#18AEFF',
                },
                fill: 'solid',
                fontSize: 14,
                fontFamily: {
                    key: 'Roboto',
                    value: `Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif`,
                },
                borderRadius: 'large',
            },
            bulletsColor: {
                branding: null,
                enabled: true,
                type: null,
                value: '#EE206F',
            },
        };
    },

    pixelsToDocumentPoints(pixels){
        return Math.ceil(parseInt(pixels) * 1.333)
    },

    colorPickerColors: [
        '#ffffff',
        '#000000',
        '#F30070',
        '#18AEFF',
        '#EB7E0A',
        '#F9D423',
        '#8274E8',
        '#2ADA2B',

        '#F2F2F2',
        '#7F7F7F',
        '#F3D9E4',
        '#D9E9F3',
        '#FBE5D5',
        '#FFF2CC',
        '#EDD9EF',
        '#D9EFDD',

        '#D8D8D8',
        '#595959',
        '#E7B4C5',
        '#B4DDE7',
        '#F7CBAC',
        '#FEE599',
        '#D7B3E0',
        '#B3E0BB',

        '#BFBFBF',
        '#3F3F3F',
        '#DB8EBC',
        '#8EBFDB',
        '#F4B183',
        '#FFD500',
        '#C78DD0',
        '#8DD091',

        '#A5A5A5',
        '#262626',
        '#962F59',
        '#2F8196',
        '#C55A11',
        '#BF9000',
        '#723581',
        '#35814C',

        '#737373',
        '#111111',
        '#641F32',
        '#1F4F64',
        '#833C0B',
        '#885E16',
        '#4C2356',
        '#235628',
    ],

    contactHeaders: [
        {
            name: 'Ignore this column',
            value: 'ignore',
        },
        {
            name: 'Account',
            value: 'account',
        },
        {
            name: 'First Name',
            value: 'firstName',
        },
        {
            name: 'Last Name',
            value: 'lastName',
        },
        {
            name: 'Email',
            value: 'email',
        },
        {
            name: 'Job Title',
            value: 'title',
        },
        {
            name: 'Phone',
            value: 'phone',
        },
        {
            name: 'Contact City',
            value: 'contactCity',
        },
        {
            name: 'Contact State',
            value: 'contactState',
        },
        {
            name: 'Mobile Phone Number',
            value: 'mobilePhone',
        },
        {
            name: 'Teams Phone',
            value: 'teamsPhone',
        },
        {
            name: 'Home Phone',
            value: 'homePhone',
        },
        {
            name: 'Lead Score',
            value: 'leadScore',
        },
        {
            name: 'Contact Status',
            value: 'contactStatus',
        },
        {
            name: 'Contact Facebook',
            value: 'contactFacebook',
        },
        {
            name: 'Contact Twitter',
            value: 'contactTwitter',
        },
        {
            name: 'Contact Linkedin',
            value: 'linkedin',
        },
        {
            name: 'Company Name',
            value: 'companyName',
        },
        {
            name: 'Company Address 1',
            value: 'address1',
        },
        {
            name: 'Company Address 2',
            value: 'address2',
        },
        {
            name: 'Company Zipcode',
            value: 'zipcode',
        },
        {
            name: 'Company City',
            value: 'city',
        },
        {
            name: 'Company State',
            value: 'state',
        },
        {
            name: 'Company Country',
            value: 'country',
        },
        {
            name: 'Company Phone',
            value: 'companyPhone',
        },
        {
            name: 'Company Sales Phone',
            value: 'salesPhone',
        },
        {
            name: 'Company Support Phone',
            value: 'supportPhone',
        },
        {
            name: 'Company Accounting Phone',
            value: 'accountingPhone',
        },
        {
            name: 'Company Fax',
            value: 'fax',
        },
        {
            name: 'Company Website',
            value: 'website',
        },
        {
            name: 'Company LinkedIn',
            value: 'companyLinkedin',
        },
        {
            name: 'Company Facebook',
            value: 'companyFacebook',
        },
        {
            name: 'Company Twitter',
            value: 'companyTwitter',
        },
        {
            name: 'Company YouTube',
            value: 'companyYoutube',
        },
        {
            name: 'Company Type',
            value: 'companyType',
        },
        {
            name: 'Company Vertical',
            value: 'companyVertical',
        },
        {
            name: 'Employee Count',
            value: 'employeeCount',
        },
        {
            name: 'Device Count',
            value: 'deviceCount',
        },
        {
            name: 'Description',
            value: 'description',
        },
    ],

    cardColors: [
                '#F30070',
                '#EB7E0A',
                '#7E5DFF',
                '#18AEFF',
                '#2ADA2B',
                '#AF1E69',
                '#492EAE',
                '#F3C213',
                '#2D84C0',
                '#1A951B',
                '#F66A7B',
                '#B33645',
                '#A97713',
                '#A14A0D',
                '#DF8BEE',
                '#282AE4',
                '#1D9CE1',
                '#5934E6',
                '#D10E68',
                '#EC3E53',
                '#D45B06',
                '#DF990E',
                '#18C219',
                '#877D88',
                '#382153',
            ],

    // Arrays

    groupBy(array, keyFactory) {
        return array.reduce((acc, item) => {
            const key = keyFactory(item);
            if (acc[key]) {
                const orderedItems = [...acc[key], item];
                return { ...acc, [key]: orderedItems };
            } else {
                return { ...acc, [key]: [item] };
            }
        }, {});
    },

    // List Formats

    conjunctionListFormatter: new Intl.ListFormat('en', { type: 'conjunction' }),

    disjunctionListFormatter: new Intl.ListFormat('en', { type: 'disjunction' }),

    createDateRange(type, options = { lifetimeMin: 0 }) {
        switch (type) {
            case 'today':
                return {
                    type,
                    start: moment().startOf('day').utc().toISOString(),
                    end: moment().endOf('day').utc().toISOString(),
                };
            case 'yesterday':
                return {
                    type,
                    start: moment().subtract(1, 'days').startOf('day').utc().toISOString(),
                    end: moment().subtract(1, 'days').endOf('day').utc().toISOString(),
                };
            case 'this-week':
                return {
                    type,
                    start: moment().startOf('week').utc().toISOString(),
                    end: moment().endOf('day').utc().toISOString(),
                };
            case 'last-week':
                return {
                    type,
                    start: moment().subtract(1, 'week').startOf('week').utc().toISOString(),
                    end: moment().subtract(1, 'week').endOf('week').utc().toISOString(),
                };
            case 'this-month':
                return {
                    type,
                    start: moment().startOf('month').utc().toISOString(),
                    end: moment().endOf('day').utc().toISOString(),
                };
            case 'last-month':
                return {
                    type,
                    start: moment().subtract(1, 'months').startOf('month').utc().toISOString(),
                    end: moment().subtract(1, 'months').endOf('month').utc().toISOString(),
                };
            case 'this-quarter':
                return {
                    type,
                    start: moment().startOf('quarter').utc().toISOString(),
                    end: moment().endOf('day').utc().toISOString(),
                };
            case 'last-quarter':
                return {
                    type,
                    start: moment().subtract(1, 'quarters').startOf('quarter').utc().toISOString(),
                    end: moment().subtract(1, 'quarters').endOf('quarter').utc().toISOString(),
                };
            case 'this-year':
                return {
                    type,
                    start: moment().startOf('year').utc().toISOString(),
                    end: moment().endOf('day').utc().toISOString(),
                };
            case 'last-year':
                return {
                    type,
                    start: moment().subtract(1, 'years').startOf('year').utc().toISOString(),
                    end: moment().subtract(1, 'years').endOf('year').utc().toISOString(),
                };
            case 'lifetime':
                return {
                    type,
                    start: moment(options.lifetimeMin).utc().toISOString(),
                    end: moment().endOf('day').utc().toISOString(),
                };
            case 'custom-range':
            default:
                return {
                    type,
                    start: null,
                    end: null,
                };
        }
    },

    status: status,

    setCardTypeData(cardType) {
        switch (cardType) {
            case 'visa':
                return {
                    cardType: 'visa',
                    cardImageSource: VisaCard
                }
            case 'mastercard':
                return {
                    cardType: 'mastercard',
                    cardImageSource: MasterCard
                }
            case 'american-express':
                return {
                    cardType: 'american-express',
                    cardImageSource: AmericanExpressCard,
                }

            case 'discover':
                return {
                    cardType: 'discover',
                    cardImageSource: DiscoverCard,
                }

            case 'jcb':
                return {
                    cardType: 'jcb',
                    cardImageSource: JcbCard
                }
            case 'maestro':
                return {
                    cardType: 'maestro',
                    cardImageSource: MaestroCard
                }
            case 'diners-club':
                return {
                    cardType: 'diners-club',
                    cardImageSource: DinersClubCard
                }
            default:
                return {
                    cardType: null,
                    cardImageSource: DefaultCard
                }
        }
    },

    hasSufficientContrast(hexColor1, hexColor2) {
        const getLuminance = (hexColor) => {
            const r = parseInt(hexColor.slice(1, 3), 16) / 255;
            const g = parseInt(hexColor.slice(3, 5), 16) / 255;
            const b = parseInt(hexColor.slice(5, 7), 16) / 255;

            const gammaCorrectedR =
                r <= 0.03928 ? r / 12.92 : Math.pow((r + 0.055) / 1.055, 2.4);
            const gammaCorrectedG =
                g <= 0.03928 ? g / 12.92 : Math.pow((g + 0.055) / 1.055, 2.4);
            const gammaCorrectedB =
                b <= 0.03928 ? b / 12.92 : Math.pow((b + 0.055) / 1.055, 2.4);

            return (
                0.2126 * gammaCorrectedR + 0.7152 * gammaCorrectedG + 0.0722 * gammaCorrectedB
            );
        };

        const luminance1 = getLuminance(hexColor1);
        const luminance2 = getLuminance(hexColor2);

        const lighter = Math.max(luminance1, luminance2);
        const darker = Math.min(luminance1, luminance2);

        const contrast = (lighter + 0.05) / (darker + 0.05);

        return contrast >= 4.5;
    },

    mapBorderRadiusOptionToPx(option) {
        if (option.toUpperCase() === 'NONE') {
            return '0px';
        } else if (option.toUpperCase() === 'SMALL') {
            return '5px';
        } else if (option.toUpperCase() === 'MEDIUM') {
            return '12px';
        } else {
            return '1000px';
        }
    },

    mapButtonConfigurationToStyles(configuration) {
        return {
            'border-radius': this.mapBorderRadiusOptionToPx(
                configuration.borderRadius
            ),

            color: configuration.textColor.value,
            'background-color':
                configuration.fill === 'solid'
                    ? configuration.buttonColor.value
                    : 'transparent',

            border:
                configuration.fill === 'outline'
                    ? `solid 1px ${configuration.buttonColor.value}`
                    : 'none',

            'font-family': configuration.fontFamily.value,
            'font-size': configuration.fontSize + 'px',
        };
    },

    getDefaultMagicBranding() {
        return {
            logos: this.getDefaultMagicLogosBranding(),
            colors: this.getDefaultMagicColorsBranding(),
            fonts: this.getDefaultMagicFontsBranding(),
            buttons: this.getDefaultMagicButtonsBranding(),
            socialMedia: this.getDefaultMagicSocialMediaBranding(),
            companyDetails: this.getDefaultMagicCompanyDetailsBranding()
        }
    },

    getDefaultMagicLogosBranding() {
        return {
            dark: {
                name: '',
                src: '',
            },
            light: {
                name: '',
                src: '',
            },
            logoSize: 100,
            additionalLogos: [],
        }
    },

    getDefaultMagicColorsBranding(){
        return {
            main: {
                primaryColor: {
                    value: '#40255D',
                },

                secondaryColor: {
                    value: '#7A5BFF',
                },

                accentColor: {
                    value: '#1982F4',
                },

                customColors: [],
            },

            emailColors: {
                emailBackgroundColor: {
                    branding: '',
                    custom: true,
                    value: '#EFEFF3',
                },

                headerAndFooterFontColor: {
                    branding: '',
                    custom: true,
                    value: '#877D88',
                },

                canvasColor: {
                    branding: '',
                    custom: true,
                    value: '#FFFFFF',
                },

                canvasFontColor: {
                    branding: 'primaryColor',
                    custom: false,
                    value: '#40255D',
                },

                primaryFontColor: {
                    branding: '',
                    custom: true,
                    value: '#FFFFFF',
                },

                secondaryFontColor: {
                    branding: '',
                    custom: true,
                    value: '#FFFFFF',
                },
            },

            landingPageColors: {
                backgroundColor: {
                    branding: '',
                    custom: true,
                    value: '#FFFFFF',
                },
            },

            collateralColors: {
                paperColor: {
                    branding: '',
                    custom: true,
                    value: '#FFFFFF',
                },
            },

            documentColors: {
                backgroundColor: {
                    branding: '',
                    custom: true,
                    value: '#FFFFFF',
                },
            },

            fontColors: {
                h1: {
                    branding: 'secondaryColor',
                    custom: false,
                    value: '#7A5BFF',
                },

                h2: {
                    branding: 'primaryColor',
                    custom: false,
                    value: '#40255D',
                },

                h3: {
                    branding: 'primaryColor',
                    custom: false,
                    value: '#40255D',
                },

                h4: {
                    branding: 'primaryColor',
                    custom: false,
                    value: '#40255D',
                },

                h5: {
                    branding: 'primaryColor',
                    custom: false,
                    value: '#40255D',
                },

                h6: {
                    branding: 'primaryColor',
                    custom: false,
                    value: '#40255D',
                },

                bodyText: {
                    branding: '',
                    custom: true,
                    value: '#877D88',
                },

                linkColor: {
                    branding: '',
                    custom: true,
                    value: '#18AEFF',
                },

                linkHoverColor: {
                    branding: '',
                    custom: true,
                    value: '#0F8BCE',
                },

                visitedLinkColor: {
                    branding: '',
                    custom: true,
                    value: '#CA3CEB',
                },

                bulletsAndNumbers: {
                    branding: 'secondaryColor',
                    custom: false,
                    value: '#7A5BFF',
                },

                paginationColor: {
                    branding: '',
                    custom: true,
                    value: '#FFFFFF',
                },
            },
        }
    },

    getDefaultMagicFontsBranding() {
        return {
            main: {
                headings: {
                    fontFamily: {
                        key: 'Roboto',
                        value:
                            "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",
                    },
                },

                body: {
                    fontFamily: {
                        key: 'Roboto',
                        value:
                            "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",
                    },
                },
            },

            landingPage: {
                heading1: {
                    branding: 'headings',
                    custom: false,
                    fontSize: 40,
                    lineHeight: 150,
                    fontFamily: {
                        key: 'Roboto',
                        value:
                            "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",
                    },
                },

                heading2: {
                    branding: 'headings',
                    custom: false,
                    fontSize: 28,
                    lineHeight: 150,
                    fontFamily: {
                        key: 'Roboto',
                        value:
                            "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",
                    },
                },

                heading3: {
                    branding: 'headings',
                    custom: false,
                    fontSize: 24,
                    lineHeight: 150,
                    fontFamily: {
                        key: 'Roboto',
                        value:
                            "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",
                    },
                },

                heading4: {
                    branding: 'headings',
                    custom: false,
                    fontSize: 20,
                    lineHeight: 150,
                    fontFamily: {
                        key: 'Roboto',
                        value:
                            "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",
                    },
                },

                heading5: {
                    branding: 'headings',
                    custom: false,
                    fontSize: 18,
                    lineHeight: 150,
                    fontFamily: {
                        key: 'Roboto',
                        value:
                            "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",
                    },
                },

                heading6: {
                    branding: 'headings',
                    custom: false,
                    fontSize: 16,
                    lineHeight: 150,
                    fontFamily: {
                        key: 'Roboto',
                        value:
                            "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",
                    },
                },

                bodyText: {
                    branding: 'body',
                    custom: false,
                    fontSize: 16,
                    lineHeight: 150,
                    fontFamily: {
                        key: 'Roboto',
                        value:
                            "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",
                    },
                },
            },

            email: {
                heading1: {
                    branding: 'headings',
                    custom: false,
                    fontSize: 40,
                    lineHeight: 150,
                    fontFamily: {
                        key: 'Roboto',
                        value:
                            "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",
                    },
                },

                heading2: {
                    branding: 'headings',
                    custom: false,
                    fontSize: 28,
                    lineHeight: 150,
                    fontFamily: {
                        key: 'Roboto',
                        value:
                            "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",
                    },
                },

                heading3: {
                    branding: 'headings',
                    custom: false,
                    fontSize: 24,
                    lineHeight: 150,
                    fontFamily: {
                        key: 'Roboto',
                        value:
                            "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",
                    },
                },

                heading4: {
                    branding: 'headings',
                    custom: false,
                    fontSize: 20,
                    lineHeight: 150,
                    fontFamily: {
                        key: 'Roboto',
                        value:
                            "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",
                    },
                },

                heading5: {
                    branding: 'headings',
                    custom: false,
                    fontSize: 18,
                    lineHeight: 150,
                    fontFamily: {
                        key: 'Roboto',
                        value:
                            "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",
                    },
                },

                heading6: {
                    branding: 'headings',
                    custom: false,
                    fontSize: 16,
                    lineHeight: 150,
                    fontFamily: {
                        key: 'Roboto',
                        value:
                            "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",
                    },
                },

                bodyText: {
                    branding: 'body',
                    custom: false,
                    fontSize: 16,
                    lineHeight: 150,
                    fontFamily: {
                        key: 'Roboto',
                        value:
                            "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",
                    },
                },
            },

            collateral: {
                heading1: {
                    branding: 'headings',
                    custom: false,
                    fontSize: 40,
                    lineHeight: 150,
                    fontFamily: {
                        key: 'Roboto',
                        value:
                            "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",
                    },
                },

                heading2: {
                    branding: 'headings',
                    custom: false,
                    fontSize: 28,
                    lineHeight: 150,
                    fontFamily: {
                        key: 'Roboto',
                        value:
                            "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",
                    },
                },

                heading3: {
                    branding: 'headings',
                    custom: false,
                    fontSize: 24,
                    lineHeight: 150,
                    fontFamily: {
                        key: 'Roboto',
                        value:
                            "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",
                    },
                },

                heading4: {
                    branding: 'headings',
                    custom: false,
                    fontSize: 20,
                    lineHeight: 150,
                    fontFamily: {
                        key: 'Roboto',
                        value:
                            "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",
                    },
                },

                heading5: {
                    branding: 'headings',
                    custom: false,
                    fontSize: 18,
                    lineHeight: 150,
                    fontFamily: {
                        key: 'Roboto',
                        value:
                            "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",
                    },
                },

                heading6: {
                    branding: 'headings',
                    custom: false,
                    fontSize: 16,
                    lineHeight: 150,
                    fontFamily: {
                        key: 'Roboto',
                        value:
                            "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",
                    },
                },

                bodyText: {
                    branding: 'body',
                    custom: false,
                    fontSize: 16,
                    lineHeight: 150,
                    fontFamily: {
                        key: 'Roboto',
                        value:
                            "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",
                    },
                },

                pagination: {
                    branding: 'body',
                    custom: false,
                    fontSize: 16,
                    lineHeight: 150,
                    fontFamily: {
                        key: 'Roboto',
                        value:
                            "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",
                    },
                },
            },

            document: {
                heading1: {
                    branding: 'headings',
                    custom: false,
                    fontSize: 40,
                    lineHeight: 150,
                    fontFamily: {
                        key: 'Roboto',
                        value:
                            "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",
                    },
                },

                heading2: {
                    branding: 'headings',
                    custom: false,
                    fontSize: 28,
                    lineHeight: 150,
                    fontFamily: {
                        key: 'Roboto',
                        value:
                            "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",
                    },
                },

                heading3: {
                    branding: 'headings',
                    custom: false,
                    fontSize: 24,
                    lineHeight: 150,
                    fontFamily: {
                        key: 'Roboto',
                        value:
                            "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",
                    },
                },

                heading4: {
                    branding: 'headings',
                    custom: false,
                    fontSize: 20,
                    lineHeight: 150,
                    fontFamily: {
                        key: 'Roboto',
                        value:
                            "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",
                    },
                },

                heading5: {
                    branding: 'headings',
                    custom: false,
                    fontSize: 18,
                    lineHeight: 150,
                    fontFamily: {
                        key: 'Roboto',
                        value:
                            "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",
                    },
                },

                heading6: {
                    branding: 'headings',
                    custom: false,
                    fontSize: 16,
                    lineHeight: 150,
                    fontFamily: {
                        key: 'Roboto',
                        value:
                            "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",
                    },
                },

                bodyText: {
                    branding: 'body',
                    custom: false,
                    fontSize: 16,
                    lineHeight: 150,
                    fontFamily: {
                        key: 'Roboto',
                        value:
                            "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",
                    },
                },

                headerAndFooter: {
                    branding: 'body',
                    custom: false,
                    fontSize: 16,
                    lineHeight: 150,
                    fontFamily: {
                        key: 'Roboto',
                        value:
                            "Roboto, Helvetica, Arial, Tahoma, 'Franklin Gothic Medium', sans-serif",
                    },
                },
            }
        }
    },

    getDefaultMagicButtonsBranding() {
        return {
            primary: {
                textColor: {
                    branding: '',
                    value: '#FFFFFF',
                },
                buttonColor: {
                    branding: 'accentColor',
                    value: '#1982F4',
                },
                fill: 'solid',
                fontSize: 14,
                fontFamily: {
                    key: 'Roboto',
                    value: 'Roboto, Helvetica, Arial, Tahoma, \'Franklin Gothic Medium\', sans-serif',
                },
                borderRadius: 'large',
            },
            secondary: {
                textColor: {
                    branding: 'accentColor',
                    value: '#1982F4',
                },
                buttonColor: {
                    branding: 'accentColor',
                    value: '#1982F4',
                },
                fill: 'outline',
                fontSize: 14,
                fontFamily: {
                    key: 'Roboto',
                    value: 'Roboto, Helvetica, Arial, Tahoma, \'Franklin Gothic Medium\', sans-serif',
                },
                borderRadius: 'large',
            },
            otherButtons: [],
        };
    },

    getDefaultMagicSocialMediaBranding() {
        return {
            colors: {
                primaryColor: {
                    branding: '',
                    value: '',
                },
                secondaryColor: {
                    branding: '',
                    value: '#FFFFFF',
                },
            },
            shape: 'circle',
            socialMediaHandles: {
                facebook: '',
                linkedin: '',
                instagram: '',
                twitter: '',
                website: '',
                youtube: ''
            },
        }
    },

    getDefaultMagicCompanyDetailsBranding() {
        return {
            name: '',
            address: '',
            city: '',
            state: '',
            zipcode: '',
            website: '',
            email: '',
            phone: '',
            emailDetails: {
                footer: '',
            }
        }
    },

    getReportFormattedDate(date) {
        const newDate = new Date(date);
        const formattedDate = newDate.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
        return formattedDate
    },

    downloadCSV(csvString, filename = "data.csv") {
        // Create a Blob from the CSV string
        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    
        // Create a link element
        const link = document.createElement("a");
        if (link.download !== undefined) {
            // Create a URL for the blob and set the download attribute
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", filename);
    
            // Append the link to the document and trigger a click event
            document.body.appendChild(link);
            link.click();
    
            // Clean up by removing the link and revoking the object URL
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        }
    }
};
